import React, { useEffect, useMemo, useState, useCallback } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import Select from "react-select";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import { leadsData } from "../../../core/data/json/leads";
import { Form, Modal } from "react-bootstrap";
import CollapseHeader from "../../../core/common/collapse-header";
import { all_routes } from "../../router/all_routes";
import Offcanvas from "react-bootstrap/Offcanvas";
import { toast } from "react-toastify";
import { fetchAllLeadSourcesActive } from "../../../api/leadsource";
import { fetchAllLeadIndustriesActive } from "../../../api/leadindustry";
import { fetchAllLeadStagesActive } from "../../../api/leadstage";
import { fetchAllLeadTypesActive } from "../../../api/leadtype";
import { fetchAllProductsActive } from "../../../api/product";
import {
  exportLeadsExcel,
  exportLeadsPDF,
  exportSelectedLeadsExcel,
  exportSelectedLeadsPDF,
  fetchAllLeads,
  getCompaniesByUserId,
  Lead,
  LeadFormData,
  updateLead,
  CompanyWithBranches,
  makeCallToLead,
  deleteLeadsBulk,
  exportLeadsReport,
  deleteLead,
} from "../../../api/lead";
import { User } from "../../../api/usermanager";
import "react-toastify/dist/ReactToastify.css";
import { Branch, createLead, CreateLeadPayload } from "../../../api/leads";
import { fetchAllProductTypesActive } from "../../../api/producttype";
import { fetchAllCustomerPotentialsActive } from "../../../api/customertype";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../core/data/redux/store";
import { fetchUsersByClientId } from "../../../api/todo";
import { highlightMatch } from "../../../core/common/highlightmatch";
import { initialSettings } from "../../../core/common/selectoption/selectoption";
import {
  deleteReduxReLeadThunk,
  fetchReduxReLeadsThunk,
} from "../../../core/data/redux/leadSlice";
import PageLoadProgressBar from "../../../core/data/json/pageLoadProgressBar";
import { MultiValue } from "react-select";
import { fetchAllLeadGivenByActive } from "../../../api/leadgivenby";
import { Dropdown, Menu, Button as ButtonAnt, Checkbox,Avatar } from "antd";
import { DownOutlined, FunnelPlotFilled, FunnelPlotOutlined } from "@ant-design/icons";
import {
  FilterOutlined,
  ClockCircleOutlined,
  PhoneOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import CountUp from "react-countup";
import SequentialHighlight from "../../../core/common/SequentialHighlight";
import ColumnManagement from "../../../core/common/ColumnManagement";
import { useColumnOrderSave } from "../../../core/common/useColumnOrderSave";
import TextCopy2 from "../../../core/common/textcopy2";
import AnimatedBadge from "../../../core/common/AnimatedBadge";
import SubmoduleHoverCard from "../../../core/common/SubCard2Button";
import ScrollToTop from "../../../core/common/ScrollToTop";
import LeadDetailsModal from "../../../core/common/LeadDetailsModal";
import ModalDeleteEffect from "../../../core/common/ModalDeleteEffect";

const columnLabels = {
  lead_name: "Lead Name",
  phone: "Contact Info",
  branch: "Branch Name",
  website: "Website URL",
  description: "Description",
  value: "Quoted Value",
  currency: "Currency",
  status: "Lead Status",
  owner: "Lead Owner",
  created_at: "Created At",
  updated_at: "Updated At",
  lead_type: "Lead Type",
  lead_source: "Lead Source",
  industry: "Industry",
  stage: "Lead Stage",
  product: "Product Name",
  no_logins: "No of Logins",
  rate_per_login: "Rate Per Login",
  product_type: "Product Type",
  customer_potential: "Customer Potential",
  contact_description: "Contact Description",
};

const setupDraggable = (modalElement: HTMLElement) => {
  if (modalElement.hasAttribute("data-draggable-setup")) return;
  modalElement.setAttribute("data-draggable-setup", "true");

  const modalDialog = modalElement.classList.contains("modal-dialog")
    ? modalElement
    : (modalElement.querySelector(".modal-dialog") as HTMLElement);
  const modalHeader = modalElement.querySelector(
    ".modal-header"
  ) as HTMLElement;

  if (!modalDialog || !modalHeader) return;

  let isDragging = false;
  let offsetX = 0;
  let offsetY = 0;

  const onMouseDown = (e: MouseEvent) => {
    if ((e.target as HTMLElement).closest("button,input,select,.btn-close"))
      return;

    isDragging = true;
    const rect = modalDialog.getBoundingClientRect();
    offsetX = e.clientX - rect.left;
    offsetY = e.clientY - rect.top;

    modalDialog.classList.remove("modal-dialog-centered");
    modalDialog.style.position = "fixed";
  };

  const onMouseMove = (e: MouseEvent) => {
    if (!isDragging) return;

    modalDialog.style.left = `${e.clientX - offsetX}px`;
    modalDialog.style.top = `${e.clientY - offsetY}px`;
  };

  const onMouseUp = () => (isDragging = false);

  modalHeader.style.cursor = "move";
  modalHeader.addEventListener("mousedown", onMouseDown);
  document.addEventListener("mousemove", onMouseMove);
  document.addEventListener("mouseup", onMouseUp);
};
const Leads = () => {
  const route = all_routes;
  const [users, setUsers] = useState<User[]>([]);
  const [sortOption, setSortOption] = useState<string>("recently_added"); // default
  const [loading, setLoading] = useState(false);
  const [filterNames, setFilterNames] = useState<string[]>([]);
  const [selectedDateRange, setSelectedDateRange] = useState<
    [Date, Date] | null
  >(null);
  const [filterCompanies, setFilterCompanies] = useState<string[]>([]);
  const [filterStatuses, setFilterStatuses] = useState<string[]>([]);
  const [filterOwners, setFilterOwners] = useState<string[]>([]);
  const [filterDates, setFilterDates] = useState<string[]>([]);
  const [stars, setStars] = useState<{ [key: number]: boolean }>({});
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState(searchQuery);
  const [leadList, setLeadList] = useState<Lead[]>([]);
  const [leads, setLeads] = useState<Lead[]>([]);
  const [orderedData, setOrderedData] = useState<Lead[]>([]);
  const [selectedLeads, setSelectedLeads] = useState<string[]>([]);
  const [userOptions, setUserOptions] = useState<
    { label: string; value: string }[]
  >([]);
  const [activeRangeLabel, setActiveRangeLabel] = useState("Last 30 Days");
  const [industryOptions, setIndustryOptions] = useState<
    { label: string; value: string }[]
  >([]);
  const [selectedIndustry, setSelectedIndustry] = useState<{
    label: string;
    value: string;
  } | null>(null);
  const [filterCompaniesSearch, setFilterCompaniesSearch] = useState("");
  const [filterStatusesSearch, setFilterStatusesSearch] = useState("");
  const [filterOwnersSearch, setFilterOwnersSearch] = useState("");
  const [filterDatesSearch, setFilterDatesSearch] = useState("");
  const [filterLeadTypes, setFilterLeadTypes] = useState<string[]>([]);
  const [leadTypeSearch, setLeadTypeSearch] = useState("");
  const [filterLeadSources, setFilterLeadSources] = useState<string[]>([]);
  const [leadSourceSearch, setLeadSourceSearch] = useState("");
  const [filterIndustries, setFilterIndustries] = useState<string[]>([]);
  const [industrySearch, setIndustrySearch] = useState("");
  const [filterStages, setFilterStages] = useState<string[]>([]);
  const [stageSearch, setStageSearch] = useState("");
  const [filterProducts, setFilterProducts] = useState<string[]>([]);
  const [createdAtFilter, setCreatedAtFilter] = useState<string[]>([]);
  const [productSearch, setProductSearch] = useState("");
  const [filterProductTypes, setFilterProductTypes] = useState<string[]>([]);
  const [productTypeSearch, setProductTypeSearch] = useState("");
  const [filterCustomerPotentials, setFilterCustomerPotentials] = useState<
    string[]
  >([]);
  const [filterContributors, setFilterContributors] = useState<string[]>([]);
  const [contributorSearch, setContributorSearch] = useState("");
  const [customerPotentialSearch, setCustomerPotentialSearch] = useState("");
  const [leadTypeOptions, setLeadTypeOptions] = useState<
    { label: string; value: string }[]
  >([]);
  const [selectedLeadType, setSelectedLeadType] = useState<{
    label: string;
    value: string;
  } | null>(null);
  const [leadStageOptions, setLeadStageOptions] = useState<
    { label: string; value: string }[]
  >([]);
  const [selectedLeadStage, setSelectedLeadStage] = useState<{
    label: string;
    value: string;
  } | null>(null);
  const [productOptions, setProductOptions] = useState<
    {
      label: string;
      value: string;
      data: {
        no_logins: number | null;
        rate_per_login: number | null;
        product_price: number;
      };
    }[]
  >([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [selectedProduct, setSelectedProduct] = useState<any[]>([]);
  const [selectedEditProduct, setSelectedEditProduct] = useState<{
    label: string;
    value: string;
    data: {
      no_logins: number | null;
      rate_per_login: number | null;
      product_price: number;
    };
  } | null>(null);
  const [selectedContributors, setSelectedContributors] = useState<
    { label: string; value: string }[]
  >([]);

  const [productTypeOptions, setProductTypeOptions] = useState<
    { label: string; value: string }[]
  >([]);
  const [customerTypeOptions, setCustomerTypeOptions] = useState<
    { label: string; value: string }[]
  >([]);
  const [leadIdToDelete, setLeadIdToDelete] = useState<string | null>(null);
  const [adduser, setAdduser] = useState(false);
  const [addcompany, setAddCompany] = useState(false);
  const [modalTitle, setModalTitle] = useState("Add New Lead");
  const data = leadsData;
  const [owner, setOwner] = useState(["Collab"]);
  const [openModal, setOpenModal] = useState(false);
  const [openModal2, setOpenModal2] = useState(false);
  const [openModal3, setOpenModal3] = useState(false);
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);
  const [leadSourceOptions, setLeadSourceOptions] = useState<
    { label: string; value: string }[]
  >([]);
  const [selectedLead, setSelectedLead] = useState<Lead | null>(null);
  const [currentLeadId, setCurrentLeadId] = useState<string>("");
  const [selectedBranch, setSelectedBranch] = useState<any | null>(null);
  const [filterNamesSearch, setFilterNamesSearch] = useState("");
  const [showRowStatus, setShowRowStatus] = useState(true); // ✅ default off
  const [leadGivenByOptions, setLeadGivenByOptions] = useState<
    { label: string; value: string }[]
  >([]);
  const [leadGivenBySearch, setLeadGivenBySearch] = useState("");
  const [filterLeadGivenBy, setFilterLeadGivenBy] = useState<string[]>([]);
  const [selectedCompany, setSelectedCompany] = useState<any | null>(null);
  const [searchParams] = useSearchParams();
  const leadIdParam = searchParams.get("lead_id");
  const dispatch = useDispatch<AppDispatch>();
  const [companies, setCompanies] = useState<any[]>([]);
  const userId = useSelector((state: RootState) => state.auth.user_id);
  const clientId = useSelector((state: RootState) => state.auth.client_id);
  const [alphaFilter, setAlphaFilter] = useState<string>("All");
  const [alphaFilterleadsource, setAlphaFilterleadsource] =
    useState<string>("All");
  const [alphaFilterleadowner, setAlphaFilterleadowner] =
    useState<string>("All");
  const [alphaFilterleadstage, setAlphaFilterleadstage] =
    useState<string>("All");
  const [alphaFilterleadindustry, setAlphaFilterleadindustry] =
    useState<string>("All");
  const [alphaFilterproduct, setAlphaFilterproduct] = useState<string>("All");
  const [alphaFilterproducttype, setAlphaFilterproducttype] =
    useState<string>("All");
  const [alphaFiltercustomerpotential, setAlphaFiltercustomerpotential] =
    useState<string>("All");
  const [alphaFilterleadtype, setAlphaFilterleadtype] = useState<string>("All");
  const [alphaFilterleadgiven, setAlphaFilterleadgiven] =
    useState<string>("All");
  const [showBulkDeleteModal, setShowBulkDeleteModal] = useState(false);
  const [filterMigratingFrom, setFilterMigratingFrom] = useState<string[]>([]);
  const [migratingFromSearch, setMigratingFromSearch] = useState("");
  const { reduxReLeadsList, reduxReLeadsLoading } = useSelector(
    (state: RootState) => state.reduxReLeads
  );
  const [leadStatusFilter, setLeadStatusFilter] = useState("all");
    const [openAccordion, setOpenAccordion] = useState<string | null>(
    "collapseTwo"
  );
    const [isDetailsOpen, setIsDetailsOpen] = useState(false);
  const [selectedLeadForModal, setSelectedLeadForModal] = useState<Lead | null>(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const userRole = useSelector((state: RootState) => state.auth.role);
  useEffect(() => {
    if (reduxReLeadsList.length === 0) {
      dispatch(fetchReduxReLeadsThunk());
    }
  }, [dispatch, reduxReLeadsList.length]);

  useEffect(() => {
    setLeadList(reduxReLeadsList);
    setLeads(reduxReLeadsList);
    setOrderedData(reduxReLeadsList);
  }, [reduxReLeadsList]);

  useEffect(() => {
    const statusParam = searchParams.get("status");
    const stageParam = searchParams.get("stage");
    const typeParam = searchParams.get("type");
    const sourceParam = searchParams.get("source");
    const ownerParam = searchParams.get("owner");
    const industryParam = searchParams.get("industry");
    const productParam = searchParams.get("product");
    const producttypeParam = searchParams.get("producttype");
    const customertypeParam = searchParams.get("customertype");
    if (ownerParam) {
      const ownerName = decodeURIComponent(ownerParam);
      setFilterOwners([ownerName]);
    }

    if (statusParam) {
      const statusName = decodeURIComponent(statusParam);
      setFilterStatuses([statusName]);
      setActiveLeadStatusTab(statusName);
    }

    if (stageParam) {
      const stageName = decodeURIComponent(stageParam);
      setFilterStages([stageName]);
      const matchingOption = leadStageOptions.find(
        (opt) => opt.label === stageName
      );
      if (matchingOption) setSelectedLeadStage(matchingOption);
    }

    if (typeParam) {
      const typeName = decodeURIComponent(typeParam);
      setFilterLeadTypes([typeName]);
      const matchingOption = leadTypeOptions.find(
        (opt) => opt.label === typeName
      );
      if (matchingOption) setSelectedLeadType(matchingOption);
    }

    if (sourceParam) {
      const sourceName = decodeURIComponent(sourceParam);
      setFilterLeadSources([sourceName]);
    }
    if (industryParam) {
      const industryName = decodeURIComponent(industryParam);
      setFilterIndustries([industryName]);
    }
    if (productParam) {
      const productName = decodeURIComponent(productParam);
      setFilterProducts([productName]);
    }
    if (producttypeParam) {
      const producttypeName = decodeURIComponent(producttypeParam);
      setFilterProductTypes([producttypeName]);
    }
    if (customertypeParam) {
      const customertypeName = decodeURIComponent(customertypeParam);
      setFilterCustomerPotentials([customertypeName]);
    }
    if (leadIdParam) {
      const foundLead = leads.find((l) => l.lead_id === leadIdParam);
      setSelectedLead(foundLead || null);
    }
  }, [searchParams, leadStageOptions, leadTypeOptions, leadSourceOptions,searchParams,reduxReLeadsList,leadIdParam,]);

  // Make delete modal draggable
  useEffect(() => {
    const makeModalDraggable = (modalId: string) => {
      const modalElement = document.getElementById(modalId);
      if (!modalElement) return;

      const modalDialog = modalElement.querySelector(
        ".modal-dialog"
      ) as HTMLElement;
      const modalHeader = modalElement.querySelector(
        ".modal-header"
      ) as HTMLElement;

      if (!modalDialog || !modalHeader) return;

      let isDragging = false;
      let currentX = 0;
      let currentY = 0;
      let initialX = 0;
      let initialY = 0;
      let startX = 0;
      let startY = 0;

      // Reset position when modal is shown
      const resetPosition = () => {
        // Reset all position variables
        currentX = 0;
        currentY = 0;
        initialX = 0;
        initialY = 0;
        startX = 0;
        startY = 0;
        isDragging = false;

        // Remove only the inline styles that were added during dragging
        modalDialog.style.position = "";
        modalDialog.style.top = "";
        modalDialog.style.left = "";
        modalDialog.style.transform = "";
        modalDialog.style.margin = "";
        modalDialog.style.transition = "";
        modalDialog.style.width = "";
        modalDialog.style.maxWidth = "";

        // Restore centered class if it was removed
        if (!modalDialog.classList.contains("modal-dialog-centered")) {
          modalDialog.classList.add("modal-dialog-centered");
        }
      };

      // Listen for modal show event - reset when modal is about to show
      const handleShow = () => {
        // Reset immediately when modal starts showing
        resetPosition();
      };

      // Listen for modal shown event - ensure reset after modal is fully displayed
      const handleShown = () => {
        // Double-check reset after modal is fully shown
        resetPosition();
      };

      // Listen for modal hidden event - reset when modal is fully hidden
      const handleHidden = () => {
        resetPosition();
      };

      modalElement.addEventListener("show.bs.modal", handleShow);
      modalElement.addEventListener("shown.bs.modal", handleShown);
      modalElement.addEventListener("hidden.bs.modal", handleHidden);

      const dragStart = (e: MouseEvent) => {
        // Only allow dragging from header, not from close button or other interactive elements
        const target = e.target as HTMLElement;
        if (
          target.closest(".btn-close") ||
          target.closest("button") ||
          target.closest("input") ||
          target.closest("select")
        ) {
          return;
        }

        if (
          e.target === modalHeader ||
          modalHeader.contains(e.target as Node)
        ) {
          isDragging = true;
          modalHeader.style.cursor = "move";

          // Get current position and size of modal dialog
          const rect = modalDialog.getBoundingClientRect();
          startX = rect.left;
          startY = rect.top;

          // Get computed styles to preserve the modal's size
          const computedStyle = getComputedStyle(modalDialog);
          const currentWidth = computedStyle.width;
          const currentMaxWidth = computedStyle.maxWidth;
          const currentMinWidth = computedStyle.minWidth;

          // Remove centered class to allow free movement
          modalDialog.classList.remove("modal-dialog-centered");

          // Set initial position based on current position
          modalDialog.style.position = "fixed";
          modalDialog.style.top = `${startY}px`;
          modalDialog.style.left = `${startX}px`;
          modalDialog.style.margin = "0";
          modalDialog.style.transform = "none";
          modalDialog.style.transition = "none";

          // Preserve the modal's width and max-width to prevent size change
          if (
            currentWidth &&
            currentWidth !== "auto" &&
            currentWidth !== "0px"
          ) {
            modalDialog.style.width = currentWidth;
          }
          if (
            currentMaxWidth &&
            currentMaxWidth !== "none" &&
            currentMaxWidth !== "0px"
          ) {
            modalDialog.style.maxWidth = currentMaxWidth;
          }
          if (
            currentMinWidth &&
            currentMinWidth !== "0px" &&
            currentMinWidth !== "auto"
          ) {
            modalDialog.style.minWidth = currentMinWidth;
          }

          initialX = e.clientX - startX;
          initialY = e.clientY - startY;
        }
      };

      const drag = (e: MouseEvent) => {
        if (!isDragging) return;

        e.preventDefault();

        // Calculate new position
        const newX = e.clientX - initialX;
        const newY = e.clientY - initialY;

        // Get modal dialog dimensions
        const rect = modalDialog.getBoundingClientRect();
        const maxX = window.innerWidth - rect.width;
        const maxY = window.innerHeight - rect.height;

        // Constrain to viewport
        const constrainedX = Math.max(0, Math.min(newX, maxX));
        const constrainedY = Math.max(0, Math.min(newY, maxY));

        // Update position
        modalDialog.style.left = `${constrainedX}px`;
        modalDialog.style.top = `${constrainedY}px`;

        // Store current position for next drag
        currentX = constrainedX;
        currentY = constrainedY;
      };

      const dragEnd = () => {
        if (isDragging) {
          isDragging = false;
          modalHeader.style.cursor = "move";
          modalDialog.style.transition = "";
          // Keep the fixed positioning during drag, but allow reset on next open
        }
      };

      // Add cursor style to header
      modalHeader.style.cursor = "move";
      modalHeader.style.userSelect = "none";

      // Event listeners
      modalHeader.addEventListener("mousedown", dragStart);
      document.addEventListener("mousemove", drag);
      document.addEventListener("mouseup", dragEnd);

      // Cleanup function
      return () => {
        modalElement.removeEventListener("show.bs.modal", handleShow);
        modalElement.removeEventListener("shown.bs.modal", handleShown);
        modalElement.removeEventListener("hidden.bs.modal", handleHidden);
        modalHeader.removeEventListener("mousedown", dragStart);
        document.removeEventListener("mousemove", drag);
        document.removeEventListener("mouseup", dragEnd);
      };
    };

    // Make delete modal draggable
    const cleanup = makeModalDraggable("delete_lead");

    return () => {
      cleanup?.();
    };
  }, []);

  useEffect(() => {
    const setupModalDraggable = (modalElement: HTMLElement) => {
      if (modalElement.hasAttribute("data-draggable-setup")) return;
      modalElement.setAttribute("data-draggable-setup", "true");

      const modalDialog = modalElement.querySelector(
        ".modal-dialog"
      ) as HTMLElement;
      const modalHeader = modalElement.querySelector(
        ".modal-header"
      ) as HTMLElement;

      if (!modalDialog || !modalHeader) return;

      let isDragging = false;
      let initialX = 0;
      let initialY = 0;
      let startX = 0;
      let startY = 0;

      const resetPosition = () => {
        isDragging = false;
        modalDialog.style.position = "";
        modalDialog.style.top = "";
        modalDialog.style.left = "";
        modalDialog.style.transform = "";
        modalDialog.style.margin = "";
        modalDialog.style.transition = "";
        modalDialog.style.width = "";
        modalDialog.style.maxWidth = "";

        if (!modalDialog.classList.contains("modal-dialog-centered")) {
          modalDialog.classList.add("modal-dialog-centered");
        }
      };

      const dragStart = (e: MouseEvent) => {
        const target = e.target as HTMLElement;
        if (
          target.closest(".btn-close") ||
          target.closest("button") ||
          target.closest("input") ||
          target.closest("select")
        ) {
          return;
        }

        if (
          e.target === modalHeader ||
          modalHeader.contains(e.target as Node)
        ) {
          isDragging = true;
          modalHeader.style.cursor = "move";

          const rect = modalDialog.getBoundingClientRect();
          startX = rect.left;
          startY = rect.top;

          const computedStyle = getComputedStyle(modalDialog);
          const currentWidth = computedStyle.width;
          const currentMaxWidth = computedStyle.maxWidth;
          const currentMinWidth = computedStyle.minWidth;

          modalDialog.classList.remove("modal-dialog-centered");

          modalDialog.style.position = "fixed";
          modalDialog.style.top = `${startY}px`;
          modalDialog.style.left = `${startX}px`;
          modalDialog.style.margin = "0";
          modalDialog.style.transform = "none";
          modalDialog.style.transition = "none";

          if (
            currentWidth &&
            currentWidth !== "auto" &&
            currentWidth !== "0px"
          ) {
            modalDialog.style.width = currentWidth;
          }
          if (
            currentMaxWidth &&
            currentMaxWidth !== "none" &&
            currentMaxWidth !== "0px"
          ) {
            modalDialog.style.maxWidth = currentMaxWidth;
          }
          if (
            currentMinWidth &&
            currentMinWidth !== "0px" &&
            currentMinWidth !== "auto"
          ) {
            modalDialog.style.minWidth = currentMinWidth;
          }

          initialX = e.clientX - startX;
          initialY = e.clientY - startY;
        }
      };

      const drag = (e: MouseEvent) => {
        if (!isDragging) return;
        e.preventDefault();

        const newX = e.clientX - initialX;
        const newY = e.clientY - initialY;

        const rect = modalDialog.getBoundingClientRect();
        const maxX = window.innerWidth - rect.width;
        const maxY = window.innerHeight - rect.height;

        const constrainedX = Math.max(0, Math.min(newX, maxX));
        const constrainedY = Math.max(0, Math.min(newY, maxY));

        modalDialog.style.left = `${constrainedX}px`;
        modalDialog.style.top = `${constrainedY}px`;
      };

      const dragEnd = () => {
        if (isDragging) {
          isDragging = false;
          modalHeader.style.cursor = "move";
          modalDialog.style.transition = "";
        }
      };

      modalHeader.style.cursor = "move";
      modalHeader.style.userSelect = "none";

      modalHeader.addEventListener("mousedown", dragStart);
      document.addEventListener("mousemove", drag);
      document.addEventListener("mouseup", dragEnd);

      const handleHidden = () => {
        resetPosition();
        modalElement.removeAttribute("data-draggable-setup");
      };

      modalElement.addEventListener("hidden.bs.modal", handleHidden);
    };

    const checkAndSetup = () => {
      const modals = document.querySelectorAll(".modal.show");
      modals.forEach((modal) => {
        const modalEl = modal as HTMLElement;
        const h4 = modalEl.querySelector("h4")?.textContent || "";

        if (
          h4.includes("Confirm Bulk Delete") &&
          !modalEl.hasAttribute("data-draggable-setup")
        ) {
          setTimeout(() => setupModalDraggable(modalEl), 50);
        }
      });
    };

    const interval = setInterval(checkAndSetup, 100);

    return () => {
      clearInterval(interval);
    };
  }, [showBulkDeleteModal]);

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        if (!userId) return;
        const data = await getCompaniesByUserId(userId);
        setCompanies(data);
      } catch (error) {
        console.error("Error loading companies", error);
      }
    };
    fetchCompanies();
  }, [userId]);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleShow1 = () => setShow2(true);
  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => {
    setSelectedLead(null);
    setLeadFormData({
      website_url: "",
      lead_description: "",
      lead_status: "Active",
      leadtype_id: "",
      leadsource_id: "",
      leadindustry_id: "",
      leadstage_id: "",
      user_id: "",
      leadgivenby_id: "",
      migrating_from: "",
    });
    setShow2(true);
  };

  const [editLeadFormData, setEditLeadFormData] = useState<LeadFormData>({
    website_url: "",
    lead_description: "",
    lead_status: "",
    lead_value: "",
    Currency: "",
    leadtype_id: "",
    leadsource_id: "",
    leadindustry_id: "",
    customerPotential_id: "",
    leadstage_id: "",
    user_id: "",
    product_id: "",
    product_type_id: "",
    branch_id: "",
    contact_id: "",
    no_logins: 1,
    rate_per_login: 0,
    leadcontributor_id: "",
    leadgivenby_id: "",
    migrating_from: "",
  });
  const [activeLeadStatusTab, setActiveLeadStatusTab] = useState<string | null>(
    null
  );

  const leadStatusTabs = useMemo(
    () => [
      { key: "Not_Contacted", label: "Not Contacted" },
      { key: "Contacted", label: "Contacted" },
      { key: "Closed", label: "Closed" },
      { key: "Lost", label: "Lost" },
    ],
    []
  );

  const statusCounts = useMemo(() => {
    const counts: Record<string, number> = {
      Not_Contacted: 0,
      Contacted: 0,
      Closed: 0,
      Lost: 0,
    };
    leads.forEach((lead) => {
      const status = lead.lead_status;
      if (counts[status] !== undefined) {
        counts[status]++;
      }
    });
    return counts;
  }, [leads]);

  const handleClose3 = () => {
    localStorage.removeItem("lastEditedLeadId");
    setShow3(false);
  };
  const handleShow3 = useCallback(
    (lead: Lead) => {
      const companyWithBranches = companies.find(
        (c) => c.company.contact_id === lead.contact?.contact_id
      );

      let matchedBranch: Branch | undefined;

      // Try to guess the branch if branch_id is not in lead
      if (lead.branch_id) {
        matchedBranch = companyWithBranches?.branches?.find(
          (b: { branch_id: string | undefined }) =>
            b.branch_id === lead.branch_id
        );
      } else if (companyWithBranches?.branches?.length === 1) {
        matchedBranch = companyWithBranches.branches[0]; // only 1 branch? use it
      }

      setSelectedCompany(companyWithBranches || null);
      setSelectedBranch(matchedBranch || null);
      setSelectedLead(lead);
      setCurrentLeadId(lead.lead_id);
      setEditLeadFormData({
        website_url: lead.website_url || "",
        lead_description: lead.lead_description || "",
        lead_status: lead.lead_status || "",
        lead_value: lead.lead_value || "",
        Currency: lead.Currency || "",
        leadtype_id: lead.leadtype?.leadtype_id || "",
        leadsource_id: lead.leadsource?.LeadSource_id || "",
        leadsource_name: lead.leadsource?.LeadSource_name || "",
        leadindustry_id: lead.leadindustry?.LeadIndustry_id || "",
        leadstage_id: lead.leadstage?.LeadStage_id || "",
        //user_id: lead.users?.id || "",
        user_id: lead.contact?.users?.id || "",
        leadcontributor_id: lead.leadcontributor_id || "",
        product_id: lead.products?.product_id || "",
        contact_id: lead.contact?.contact_id || "",
        contact_name: lead.contact?.contact_person_name || "",
        company_phone: lead.contact?.company_phone || "",
        contact_Company_name: lead.contact?.company_name || "",
        branch_id: matchedBranch?.branch_id || "",
        product_type_id: lead.producttype?.product_type_id || "",
        customerPotential_id: lead.customertypes?.customerPotential_id || "",
        no_logins: lead.no_logins || lead.products?.no_logins || 0,
        rate_per_login:
          lead.rate_per_login || lead.products?.product_price || 0,
        leadgivenby_id: lead.leadgiven_by?.leadgivenby_id || "",
        LeadGivenBy_name: lead.leadgiven_by?.LeadGivenBy_name || "",
        migrating_from: lead?.migrating_from || "",
      });
      // ✅ Pre-fill contributors multi-select
      setSelectedContributors(
        lead.leadcontributor_id
          ? lead.leadcontributor_id.split(",").map((id) => {
              const found = userOptions.find((u) => u.value === id);
              return found || { label: id, value: id };
            })
          : []
      );
      const selectedProductOption = productOptions.find(
        (opt) => opt.value === lead.products?.product_id
      );
      setSelectedEditProduct(selectedProductOption || null);

      setShow3(true);
    },
    [companies, productOptions, userOptions]
  );
  const handleEditLeadSubmit = async () => {
    try {
      const form = editLeadFormData;
      form.leadcontributor_id = editContributorIds;

      if (!form.contact_id) return toast.error("Company name is required.");
      // if (!form.branch_id) return toast.error("Branch is required.");
      if (!form.leadsource_id) return toast.error("Lead Source is required.");
      //if (!form.leadindustry_id) return toast.error("Lead Industry is required.");
      if (!form.leadtype_id) return toast.error("Lead Type is required.");
      if (!form.leadstage_id) return toast.error("Lead Stage is required.");
      if (!form.product_id) return toast.error("Product is required.");
      if (!form.product_type_id)
        return toast.error("Product Type is required.");
      if (!form.customerPotential_id)
        return toast.error("Customer Potential is required.");
      //if (!form.lead_value) return toast.error("Quoted Value is required.");
      if (!form.Currency) return toast.error("Currency is required.");
      if (!form.lead_status) return toast.error("Lead Status is required.");
      //if (!form.leadowner_id) return toast.error("Assign To (User) is required.");
      // ✅ Check proposal status before creating lead

      // const proposals = await fetchAllProposals();
      // const hasAcceptedProposal = proposals.some(
      //   (proposal) =>
      //     proposal.status === "Accepted" &&
      //     proposal.leads?.lead_id === currentLeadId
      // );

      // if (!hasAcceptedProposal) {
      //   toast.error("Proposal not accepted for this lead. Cannot update lead.");
      //   return;
      // }

      await updateLead(currentLeadId, form);
      toast.success("Lead updated successfully");
      handleClose3();
      await refreshLeads();
    } catch (err) {
      console.error("Edit error:", err);
      toast.error("Failed to update lead.");
    }
  };

  const filteredAndSortedLeads = useMemo(
    () =>
      leads
        .filter((lead) => {
          const name = lead.contact?.contact_person_name || "";
          const company = lead.contact?.company_name || "";
          const status = lead.lead_status || "";
          const owner = lead.users?.name || "";
          const leadId = lead.lead_id || "";
          const website = lead.contact?.website_url || "";
          const description = lead.lead_description || "";
          const leadsource = lead.leadsource?.LeadSource_name || "";
          const leadtype = lead.leadtype?.leadtype_name || "";
          const industry = lead.leadindustry?.LeadIndustry_name || "";
          const stage = lead.leadstage?.LeadStage_name || "";
          const product = lead.products?.product_name || "";
          const producttype = lead.producttype?.product_name || "";
          const customerpot = lead.customertypes?.customerPotential_name || "";
          const contactdescription = lead.contact?.company_remark || "";
          const mail = lead.contact?.company_mail || "";
          const quotedvalue = lead.lead_value || "";
          const phone_no = lead.contact?.company_name || "";
          const currency = lead.Currency || "";
          const contributor = lead.contributor?.name || "";
          const leadgiven = lead.leadgiven_by?.LeadGivenBy_name || "";
          const migratingFrom = lead.migrating_from || "";

          const query = debouncedSearchQuery.toLowerCase();
          const searchMatch =
            name.toLowerCase().includes(query) ||
            company.toLowerCase().includes(query) ||
            lead.contact?.company_mail?.toLowerCase().includes(query) ||
            lead.contact?.company_phone?.toLowerCase().includes(query) ||
            status.toLowerCase().includes(query) ||
            owner.toLowerCase().includes(query) ||
            description.toLowerCase().includes(query) ||
            leadsource.toLowerCase().includes(query) ||
            leadtype.toLowerCase().includes(query) ||
            industry.toLowerCase().includes(query) ||
            stage.toLowerCase().includes(query) ||
            product.toLowerCase().includes(query) ||
            producttype.toLowerCase().includes(query) ||
            customerpot.toLowerCase().includes(query) ||
            contactdescription.toLowerCase().includes(query) ||
            mail.toLowerCase().includes(query) ||
            quotedvalue.toLowerCase().includes(query) ||
            phone_no.toLowerCase().includes(query) ||
            currency.toLowerCase().includes(query) ||
            contributor.toLowerCase().includes(query) ||
            leadgiven.toLowerCase().includes(query) ||
            website.toLowerCase().includes(query) ||
            migratingFrom.toLowerCase().includes(query);

          const alphaMatch =
            alphaFilter === "All" ||
            company.toLowerCase().startsWith(alphaFilter.toLowerCase());

          const alphaMatches =
            alphaFilterleadsource === "All" ||
            (lead.leadsource?.LeadSource_name || "")
              .toLowerCase()
              .startsWith(alphaFilterleadsource.toLowerCase());
          const alphaMat =
            alphaFilterleadowner === "All" ||
            (lead.users?.name || "")
              .toLowerCase()
              .startsWith(alphaFilterleadowner.toLowerCase());
          const alphaMatleadstage =
            alphaFilterleadstage === "All" ||
            (lead.leadstage?.LeadStage_name || "")
              .toLowerCase()
              .startsWith(alphaFilterleadstage.toLowerCase());
          const alphaMatleadtype =
            alphaFilterleadtype === "All" ||
            (lead.leadtype?.leadtype_name || "")
              .toLowerCase()
              .startsWith(alphaFilterleadtype.toLowerCase());
          const alphaMatleadindustry =
            alphaFilterleadindustry === "All" ||
            (lead.leadindustry?.LeadIndustry_name || "")
              .toLowerCase()
              .startsWith(alphaFilterleadindustry.toLowerCase());
          const alphaMatproduct =
            alphaFilterproduct === "All" ||
            (lead.products?.product_name || "")
              .toLowerCase()
              .startsWith(alphaFilterproduct.toLowerCase());
          const alphaMatproducttype =
            alphaFilterproducttype === "All" ||
            (lead.producttype?.product_name || "")
              .toLowerCase()
              .startsWith(alphaFilterproducttype.toLowerCase());
          const alphaMatcustomerpotential =
            alphaFiltercustomerpotential === "All" ||
            (lead.customertypes?.customerPotential_name || "")
              .toLowerCase()
              .startsWith(alphaFiltercustomerpotential.toLowerCase());
          const alphaMatleadgiven =
            alphaFilterleadgiven === "All" ||
            (lead.leadgiven_by?.LeadGivenBy_name || "")
              .toLowerCase()
              .startsWith(alphaFilterleadgiven.toLowerCase());

              const leadStatusDropdownMatch =
  leadStatusFilter === "all" ||
  lead.lead_status?.toLowerCase() === leadStatusFilter.toLowerCase();

          const nameMatch =
            filterNames.length === 0 || filterNames.includes(name);
          const companyMatch =
            filterCompanies.length === 0 || filterCompanies.includes(company);
          const statusMatch =
            (filterStatuses.length === 0 || filterStatuses.includes(status)) &&
            (activeLeadStatusTab === null || status === activeLeadStatusTab);

          const contributorMatch =
            filterContributors.length === 0 ||
            (lead.leadcontributor_names &&
              lead.leadcontributor_names.some((c) =>
                filterContributors.includes(c)
              )) ||
            (lead.contributor?.name &&
              filterContributors.includes(lead.contributor.name));
          const ownerMatch =
            filterOwners.length === 0 || filterOwners.includes(owner);
          const leadTypeMatch =
            filterLeadTypes.length === 0 ||
            filterLeadTypes.includes(lead.leadtype?.leadtype_name || "");
          const leadSourceMatch =
            filterLeadSources.length === 0 ||
            filterLeadSources.includes(lead.leadsource?.LeadSource_name || "");
          const industryMatch =
            filterIndustries.length === 0 ||
            filterIndustries.includes(
              lead.leadindustry?.LeadIndustry_name || ""
            );
          const stageMatch =
            filterStages.length === 0 ||
            filterStages.includes(lead.leadstage?.LeadStage_name || "");
          const productMatch =
            filterProducts.length === 0 ||
            filterProducts.includes(lead.products?.product_name || "");
          const productTypeMatch =
            filterProductTypes.length === 0 ||
            filterProductTypes.includes(lead.producttype?.product_name || "");
          const customerPotentialMatch =
            filterCustomerPotentials.length === 0 ||
            filterCustomerPotentials.includes(
              lead.customertypes?.customerPotential_name || ""
            );
          const leadGivenByMatch =
            filterLeadGivenBy.length === 0 ||
            filterLeadGivenBy.includes(
              lead.leadgiven_by?.LeadGivenBy_name || ""
            );

            const createdAtRaw = lead.created_at
  ? new Date(lead.created_at).toISOString().split("T")[0]
  : "";

const createdAtMatch =
  filterDates.length === 0 || filterDates.includes(createdAtRaw);


          const dateMatch =
            !selectedDateRange ||
            (lead.created_at &&
              new Date(lead.created_at) >= selectedDateRange[0] &&
              new Date(lead.created_at) <= selectedDateRange[1]);
          const leadIdMatch = !leadIdParam || lead.lead_id === leadIdParam;
          const migratingFromMatch =
            filterMigratingFrom.length === 0 ||
            filterMigratingFrom.some((term) =>
              migratingFrom.toLowerCase().includes(term.toLowerCase())
            );
          return (
            searchMatch &&
            nameMatch &&
            companyMatch &&
            statusMatch &&
            ownerMatch &&
            dateMatch &&
            leadTypeMatch &&
            leadSourceMatch &&
            industryMatch &&
            stageMatch &&
            productMatch &&
            productTypeMatch &&
            customerPotentialMatch &&
            leadGivenByMatch &&
            contributorMatch &&
            createdAtMatch && 
            alphaMatch &&
            alphaMatches &&
            alphaMat &&
            alphaMatleadtype &&
            alphaMatleadstage &&
            alphaMatleadindustry &&
            alphaMatproduct &&
            alphaMatproducttype &&
            alphaMatcustomerpotential &&
            alphaMatleadgiven &&
            leadIdMatch &&
            leadStatusDropdownMatch &&
            migratingFromMatch
          );
        })
        .sort((a, b) => {
          if (sortOption === "ascending") {
            return (a.contact?.company_name || "").localeCompare(
              b.contact?.company_name || ""
            );
          } else if (sortOption === "descending") {
            return (b.contact?.company_name || "").localeCompare(
              a.contact?.company_name || ""
            );
          } else if (sortOption === "recently_added") {
            return (
              new Date(b.created_at || "").getTime() -
              new Date(a.created_at || "").getTime()
            );
          }
          return 0;
        }),
    [
      leads,
      debouncedSearchQuery,
      filterNames,
      filterCompanies,
      filterStatuses,
      activeLeadStatusTab,
      filterOwners,
      selectedDateRange,
      filterLeadTypes,
      filterLeadSources,
      filterIndustries,
      filterStages,
      filterProducts,
      filterProductTypes,
      filterCustomerPotentials,
      filterLeadGivenBy,
      filterContributors,
      sortOption,
      leadIdParam,
      alphaFilter,
      alphaFilterleadowner,
      alphaFilterleadsource,
      alphaFilterleadstage,
      alphaFilterleadtype,
      alphaFilterproduct,
      alphaFilterproducttype,
      alphaFilterleadindustry,
      alphaFiltercustomerpotential,
      alphaFilterleadgiven,
      filterMigratingFrom,
      leadStatusFilter,
      filterDates
    ]
  );
  const paginatedLeads = useMemo(() => {
    const start = (currentPage - 1) * pageSize;
    return filteredAndSortedLeads.slice(start, start + pageSize);
  }, [filteredAndSortedLeads, currentPage, pageSize]);
  const handleFilterChange = useCallback(
    (
      value: string,
      list: string[],
      setList: React.Dispatch<React.SetStateAction<string[]>>
    ) => {
      if (list.includes(value)) {
        setList(list.filter((item) => item !== value));
      } else {
        setList([...list, value]);
      }
    },
    []
  );

  useEffect(() => {
    const lastId = localStorage.getItem("lastEditedLeadId");
    if (lastId) {
      const fetchLead = async () => {
        const leads = await fetchAllLeads();
        const found = leads.find((l) => l.lead_id === lastId);
        if (found) handleShow3(found);
      };
      fetchLead();
    }
  }, [handleShow3]);

  useEffect(() => {
    const loadAllDropdownData = async () => {
      try {
        const [
          leadTypes,
          leadStages,
          products,
          leadSources,
          industries,
          productTypes,
          customerTypes,
          leadGivenBy,
        ] = await Promise.all([
          fetchAllLeadTypesActive(),
          fetchAllLeadStagesActive(),
          fetchAllProductsActive(),
          fetchAllLeadSourcesActive(),
          fetchAllLeadIndustriesActive(),
          fetchAllProductTypesActive(),
          fetchAllCustomerPotentialsActive(),
          fetchAllLeadGivenByActive(),
        ]);

        setLeadTypeOptions(
          leadTypes.map((type) => ({
            label: type.leadtype_name,
            value: type.leadtype_id,
          }))
        );

        setLeadStageOptions(
          leadStages.map((stage) => ({
            label: stage.LeadStage_name,
            value: stage.LeadStage_id!,
          }))
        );

        setProductOptions(
          products.map((product) => ({
            label: `${product.product_name} (₹${product.product_price})`,
            value: product.product_id!,
            data: {
              no_logins: product.no_logins ?? null,
              rate_per_login: product.rate_per_login ?? null,
              product_price: product.product_price ?? 0,
            },
          }))
        );

        const formattedLeadSources = leadSources.map((item) => ({
          label: item.LeadSource_name,
          value: item.LeadSource_id || item.LeadSource_name,
        }));
        setLeadSourceOptions(formattedLeadSources);

        const formattedIndustries = industries.map((item) => ({
          label: item.LeadIndustry_name,
          value: item.LeadIndustry_id || item.LeadIndustry_name,
        }));
        setIndustryOptions(formattedIndustries);

        const formattedLeadGivenBy = leadGivenBy.map((item) => ({
          label: item.LeadGivenBy_name,
          value: item.leadgivenby_id || item.LeadGivenBy_name,
        }));
        setLeadGivenByOptions(formattedLeadGivenBy);

        setProductTypeOptions(
          productTypes.map((p) => ({
            label: p.product_name,
            value: p.product_type_id!,
          }))
        );

        setCustomerTypeOptions(
          customerTypes.map((c) => ({
            label: c.customerPotential_name,
            value: c.customerPotential_id!,
          }))
        );
      } catch (error) {
        console.error("Error loading dropdown data:", error);
      }
    };
    loadAllDropdownData();
  }, []);

  useEffect(() => {
    if (!clientId) return;
    if (clientId) {
      fetchUsersByClientId(clientId)
        .then((data) => {
          setUsers(data);
          setUserOptions(
            data.map((user) => ({
              label: user.name,
              value: user.id!,
            }))
          );
        })
        .catch((error) => {
          console.error("Error loading users", error);
        });
    }
  }, [clientId]);

  const handleStarToggle = useCallback((index: number) => {
    setStars((prevStars) => ({
      ...prevStars,
      [index]: !prevStars[index],
    }));
  }, []);

 const handleBulkDelete = async () => {
    if (selectedLeads.length === 0) return;

    try {
      await deleteLeadsBulk(selectedLeads);
      toast.success(`Deleted ${selectedLeads.length} lead${selectedLeads.length > 1 ? 's' : ''} successfully`);
      refreshLeads();
      setSelectedLeads([]);
    } catch (error) {
      toast.error("Failed to delete selected leads.");
    } finally {
      setLoading(false);
    }
  };

  const [leadFormData, setLeadFormData] = useState<LeadFormData>({
    website_url: "",
    lead_description: "",
    lead_status: "Not_Contacted",
    lead_value: "",
    Currency: "",
    leadtype_id: "",
    leadsource_id: "",
    leadindustry_id: "",
    customerPotential_id: "",
    leadstage_id: "",
    user_id: "",
    product_id: "",
    product_type_id: "",
    branch_id: "",
    contact_id: "",
    no_logins: 0,
    rate_per_login: 0,
    leadgivenby_id: "",
    migrating_from: "",
  });
  const refreshLeads = async () => {
    try {
      const resultAction = await dispatch(fetchReduxReLeadsThunk()).unwrap();
      setLeadList(resultAction);
      setLeads(resultAction);
      setOrderedData(resultAction);
      // toast.success("Leads refreshed successfully");
    } catch (err) {
      toast.error("Failed to refresh leads.");
      console.error("Refresh error:", err);
    }
  };

  const handleUpdateLead = async () => {
    try {
      if (!currentLeadId) {
        toast.error("No lead selected for update");
        return;
      }

      const result = await updateLead(currentLeadId, leadFormData);
      if (result) {
        toast.success("Lead updated successfully!");
        handleClose3(); // close modal or offcanvas
        await refreshLeads(); // refresh lead list
      }
    } catch (err) {
      toast.error("Failed to update lead.");
      console.error("Update error:", err);
    }
  };

  const handleDeleteLead = async (leadId: string) => {
    setIsDeleting(true);
    try {
      await deleteLead(leadId); // your existing API call
      toast.success("Lead deleted successfully");
      // Refresh leads list
      await refreshLeads(); // or however you refresh (fetchAllLeads, etc.)
      setSelectedLeads((prev) => prev.filter(id => id !== leadId));
    } catch (error) {
      console.error("Delete lead failed:", error);
      toast.error("Failed to delete lead");
    } finally {
      setIsDeleting(false);
    }
  };

  const defaultVisibleColumns: Record<string, boolean> = {
    SI_no: true,
    lead_name: true, // Renamed from companyName
    phone: true, // Renamed from contact_info
    branch: false, // Renamed from branch_name
    website: false, // Renamed from website_url
    description: false, // Renamed from lead_description
    value: true, // Renamed from lead_value
    currency: false, // Renamed from Currency
    status: true, // Renamed from leadStatus
    owner: true, // Renamed from leadOwner
    created_at: true,
    updated_at: false,
    lead_type: false, // Renamed from leadtype_name
    lead_source: false, // Renamed from leadsource_name
    industry: false, // Renamed from leadindustry_name
    stage: false, // Renamed from leadstage_name
    product: true, // Renamed from product_name
    no_logins: false,
    rate_per_login: false,
    product_type: false, // Renamed from product_type
    customer_potential: false, // Renamed from customer_potential
    contact_description: false,
    action: true,
  };

  const defaultColumnOrder = [
    "lead_name",
    "phone",
    "branch",
    "website",
    "description",
    "value",
    "currency",
    "status",
    "owner",
    "created_at",
    "updated_at",
    "lead_type",
    "lead_source",
    "industry",
    "stage",
    "product",
    "no_logins",
    "rate_per_login",
    "product_type",
    "customer_potential",
    "contact_description",
  ];

  const [visibleColumns, setVisibleColumns] = useState<Record<string, boolean>>(
    defaultVisibleColumns
  );

  const [columnKeys, setColumnKeys] = useState<string[]>(() => {
    const saved = localStorage.getItem("leadsColumnKeys");
    if (saved) {
      const parsed = JSON.parse(saved);
      // Migration of old keys
      const keyMap: Record<string, string> = {
        companyName: "lead_name",
        contact_info: "phone",
        branch_name: "branch",
        website_url: "website",
        lead_description: "description",
        lead_value: "value",
        Currency: "currency",
        leadStatus: "status",
        leadOwner: "owner",
        leadtype_name: "lead_type",
        leadsource_name: "lead_source",
        leadindustry_name: "industry",
        leadstage_name: "stage",
        product_name: "product",
        product_type: "product_type",
        customer_potential: "customer_potential",
        contact_description: "contact_description",
      };
      return parsed.map((k: string) => keyMap[k] || k);
    }
    return defaultColumnOrder;
  });

  // Hook for save prompt on navigation/refresh
  const { SaveModal } = useColumnOrderSave({
    columnKeys,
    localStorageKey: "leadsColumnKeys",
    defaultOrder: defaultColumnOrder,
  });

  const handleColumnToggle = useCallback((key: string) => {
    setVisibleColumns((prev) => ({ ...prev, [key]: !prev[key] }));
  }, []);

    const renderMultiFilterDropdown = ({
    label, // e.g., "Lead Owner"
    filterState, // e.g., filterOwners
    setFilterState, // e.g., setFilterOwners
    uniqueItems, // e.g., uniqueOwners
    alphaFilterState, // e.g., alphaFilterleadowner
    setAlphaFilterState, // e.g., setAlphaFilterleadowner
    searchQuery, // Pass from component
    placeholder = "ALL", // Optional: for A-Z button
  }: {
    label: string;
    filterState: string[];
    setFilterState: React.Dispatch<React.SetStateAction<string[]>>;
    uniqueItems: string[];
    alphaFilterState: string;
    setAlphaFilterState: React.Dispatch<React.SetStateAction<string>>;
    searchQuery: string;
    placeholder?: string;
  }) => (
    <div
      className="d-flex align-items-center justify-content-between"
      style={{ height: 28, whiteSpace: "nowrap" }}
      onClick={(e) => e.stopPropagation()}
    >
      <span className="me-2">{label}</span>

      {/* Multi-Select Filter with Counts */}
      <Dropdown
        trigger={["click"]}
        overlay={
          <Menu
            selectedKeys={filterState}
            style={{ width: 240, maxHeight: 300, overflowY: "auto" }}
            onClick={(e) => e.domEvent.stopPropagation()}
          >
            {/* All Option */}
            <Menu.Item
              key="all"
              onClick={() => setFilterState([])}
              className="d-flex justify-content-between align-items-center"
            >
              <Checkbox checked={filterState.length === 0}>
                All {label}
              </Checkbox>
              <span className="text-muted small ms-3">
                ({(leads.length || 0).toLocaleString()}) {/* Total count */}
              </span>
            </Menu.Item>

            <Menu.Divider />

            {/* Items with Counts */}
            {uniqueItems.map((item) => {
              const isChecked = filterState.includes(item);
              const count = leads.filter((lead) => {
                // Adjust based on column (e.g., for owners: lead.users?.name)
                if (label === "Lead Owner") return lead.users?.name === item;
                if (label === "Lead Type")
                  return lead.leadtype?.leadtype_name === item;
                if (label === "Lead Source")
                  return lead.leadsource?.LeadSource_name === item;
                if (label === "Lead Industry")
                  return lead.leadindustry?.LeadIndustry_name === item;
                if (label === "Stage")
                  return lead.leadstage?.LeadStage_name === item;
                if (label === "Course")
                  return lead.products?.product_name === item;
                if (label === "Course Type")
                  return lead.producttype?.product_name === item;
                if (label === "Customer Potential")
                  return lead.customertypes?.customerPotential_name === item;
                return false;
              }).length;

              return (
                <Menu.Item
                  key={item}
                  onClick={() => {
                    setFilterState((prev) =>
                      isChecked
                        ? prev.filter((v) => v !== item)
                        : [...prev, item]
                    );
                  }}
                  className="d-flex justify-content-between align-items-center"
                >
                  <Checkbox checked={isChecked}>{item || "Unknown"}</Checkbox>
                  <span className="text-muted small ms-3">
                    ({count.toLocaleString()})
                  </span>
                </Menu.Item>
              );
            })}
          </Menu>
        }
      >
        <ButtonAnt
          size="small"
          type="text"
          onClick={(e) => e.stopPropagation()}
          className="me-1"
        >
          <FunnelPlotFilled
            style={{
              fontSize: 15,
              color: filterState.length > 0 ? "#1890ff" : "#666",
            }}
          />
          {filterState.length > 0 && (
            <span className="ms-1 small fw-semibold">{filterState.length}</span>
          )}
        </ButtonAnt>
      </Dropdown>

      {/* Alphabetical A-Z Filter */}
      <Dropdown
        trigger={["click"]}
        onOpenChange={(open) =>
          open && setTimeout(() => document.body.click(), 0)
        }
        overlay={
          <Menu
            selectedKeys={alphaFilterState ? [alphaFilterState] : ["All"]}
            onClick={({ key }) => setAlphaFilterState(key === "All" ? "" : key)}
            style={{ width: 50, maxHeight: 250, overflow: "auto" }}
          >
            <Menu.Item key="All" className="text-center">
              All
            </Menu.Item>
            {Array.from("ABCDEFGHIJKLMNOPQRSTUVWXYZ").map((letter) => (
              <Menu.Item key={letter} className="text-center">
                {letter}
              </Menu.Item>
            ))}
          </Menu>
        }
      >
        <ButtonAnt
          size="small"
          type="text"
          onClick={(e) => e.stopPropagation()}
          style={{
            fontSize: 12,
            height: 17,
            padding: "0 8px",
            border: "1px solid #d9d9d9",
            background: "#fafafa",
          }}
        >
          {alphaFilterState ? alphaFilterState.toUpperCase() : "ALL"}
          <DownOutlined style={{ fontSize: 10, marginLeft: 4 }} />
        </ButtonAnt>
      </Dropdown>
    </div>
  );
  
  const uniqueNames = useMemo(
    () =>
      Array.from(
        new Set(leads.map((l) => l.contact?.contact_person_name || ""))
      ).filter((n) => n),
    [leads]
  );
  const uniqueCompanies = useMemo(
    () =>
      Array.from(
        new Set(leads.map((l) => l.contact?.company_name || ""))
      ).filter((n) => n),
    [leads]
  );
  const uniqueStatuses = useMemo(
    () =>
      Array.from(new Set(leads.map((l) => l.lead_status || ""))).filter(
        (n) => n
      ),
    [leads]
  );
  const uniqueOwners = useMemo(
    () =>
      Array.from(new Set(leads.map((l) => l.users?.name || ""))).filter(
        (n) => n
      ),
    [leads]
  );
  const uniqueLeadTypes = useMemo(
    () =>
      Array.from(
        new Set(leads.map((l) => l.leadtype?.leadtype_name || ""))
      ).filter((n) => n),
    [leads]
  );
  const uniqueLeadSources = useMemo(
    () =>
      Array.from(
        new Set(leads.map((l) => l.leadsource?.LeadSource_name || ""))
      ).filter((n) => n),
    [leads]
  );
  const uniqueIndustries = useMemo(
    () =>
      Array.from(
        new Set(leads.map((l) => l.leadindustry?.LeadIndustry_name || ""))
      ).filter((n) => n),
    [leads]
  );
  const uniqueStages = useMemo(
    () =>
      Array.from(
        new Set(leads.map((l) => l.leadstage?.LeadStage_name || ""))
      ).filter((n) => n),
    [leads]
  );
  const uniqueProducts = useMemo(
    () =>
      Array.from(
        new Set(leads.map((l) => l.products?.product_name || ""))
      ).filter((n) => n),
    [leads]
  );
  const uniqueProductTypes = useMemo(
    () =>
      Array.from(
        new Set(leads.map((l) => l.producttype?.product_name || ""))
      ).filter((n) => n),
    [leads]
  );
  const uniqueCustomerPotentials = useMemo(
    () =>
      Array.from(
        new Set(leads.map((l) => l.customertypes?.customerPotential_name || ""))
      ).filter((n) => n),
    [leads]
  );

  const handleAccordionToggle = useCallback((sectionId: string) => {
    setOpenAccordion((prev) => (prev === sectionId ? null : sectionId));
  }, []);
 const columns = useMemo(() => {
    const allColumnsMap: Record<string, any> = {
      index: {
        title: "S.No",
        key: "index",
        dataIndex: "SI_no",
        fixed: "left",
        width: 70,
        render: (_text: any, _record: any, index: number) =>
          (currentPage - 1) * pageSize + index + 1,
      },
      lead_name: {
        title: (
          <div
            className="flex items-center justify-between"
            style={{ height: 22, whiteSpace: "nowrap" }}
            onClick={(e) => e.stopPropagation()} // ← prevents header sort/expand
          >
            <span className="me-2">Lead Name</span>

            {/* Ant Design Dropdown – pure, tiny, beautiful */}
            <Dropdown
              trigger={["click"]}
              overlay={
                <Menu
                  selectedKeys={alphaFilter ? [alphaFilter] : ["All"]}
                  onClick={({ key }) =>
                    setAlphaFilter(key === "All" ? "All" : String(key))
                  }
                  style={{ width: 50, maxHeight: 250, overflow: "auto" }}
                >
                  <Menu.Item key="All" className="text-center">
                    All
                  </Menu.Item>
                  {Array.from("ABCDEFGHIJKLMNOPQRSTUVWXYZ").map((letter) => (
                    <Menu.Item key={letter} className="text-center">
                      {letter}
                    </Menu.Item>
                  ))}
                </Menu>
              }
            >
              <ButtonAnt
                size="small"
                type="text"
                onClick={(e) => e.stopPropagation()}
                style={{
                  fontSize: 12,
                  height: 17,
                  padding: "0 8px",
                  border: "1px solid #d9d9d9",
                  background: "#fafafa",
                }}
              >
                {alphaFilter ? alphaFilter.toUpperCase() : "ALL"}
                <DownOutlined style={{ fontSize: 10, marginLeft: 4 }} />
              </ButtonAnt>
            </Dropdown>
          </div>
        ),
        key: "lead_name",
        fixed: "left",
        width: 280,
        render: (_: any, record: Lead) => {
          const companyName = record.contact?.company_name || "N/A";
          const contactName = record.contact?.contact_person_name || "N/A";
          const initial = companyName.charAt(0).toUpperCase();

          return (
            <div className="d-flex align-items-center gap-2">  
                <Avatar
                  shape="square"
                  className="btn btn-primary"
                  onClick={() => handleShow3(record)}
                  style={{

                    width: 36,
                    height: 36,
                    fontSize: 16,
                    fontWeight: 600,
                  cursor: "pointer",
                  }}
                >
                  {initial}
                </Avatar>
                <div className="d-flex flex-column">
                  <strong className="fw-semibold text-dark">
                    {highlightMatch(companyName, searchQuery)}
                  </strong>
                  <span className="text-muted">
                    {highlightMatch(contactName, searchQuery)}
                  </span>
                </div>
            </div>
          );
        },
      },

      phone: {
        title: "Contact Info",
        key: "phone",
        render: (_: any, record: Lead) => {
          const mail = record.contact?.company_mail || "";
          const phone = record.contact?.company_phone || "";

          return (
            <div className="d-flex flex-column gap-1">
              {/* EMAIL */}
              <TextCopy2
                text={mail.trim() || "N/A"}
                searchQuery={searchQuery}
                showEmailIcon={true}
              />

              {/* PHONE */}
              <TextCopy2
                text={phone.trim() || "N/A"}
                searchQuery={searchQuery}
                showPhoneIcon={true}
              />
            </div>
          );
        },
      },

      branch: {
        title: "Branch Name",
        key: "branch",
        render: (_: any, record: Lead) => {
          const selectedBranch = record.contact?.branch?.find(
            (b) => b.branch_id === record.branch_id
          );
          return selectedBranch?.branch_name || "N/A";
        },
      },
      website: {
        title: "Website URL",
        key: "website",
        render: (_: any, record: Lead) => {
          const website = record.contact?.website_url || "";

          return (
            <TextCopy2
              text={website.trim() || "N/A"}
              searchQuery={searchQuery}
              showWebsiteIcon={true}
            />
          );
        },
      },

      description: {
        title: "Description",
        key: "description",
        ellipsis: true,
        width: 240, // 👈 control column width (recommended)
        render: (_: any, record: Lead) => {
          const value = record.lead_description || "N/A";

          return (
            <span
              style={{
                display: "inline-block",
                width: "100%",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {value}
            </span>
          );
        },
      },

      value: {
        title: "Quoted Value",
        key: "value",
        render: (_: any, record: Lead) =>
          highlightMatch(record.lead_value || "N/A", searchQuery),
      },
      currency: {
        title: "Currency",
        key: "currency",
        render: (_: any, record: Lead) => {
          const currency = record.Currency || "";

          return (
            <TextCopy2
              text={currency || "N/A"}
              showCurrencyIcon
              currency={currency as "INR" | "USD" | "EUR" | "GBP"}
              showText={true}
              showIcon={false}   // optional: hide copy icon if you want
            />
          );
        },
      },

      status: {
        title: (
          <div
            className="d-flex align-items-center justify-content-between"
            style={{ height: 28, whiteSpace: "nowrap" }}
            onClick={(e) => e.stopPropagation()}
          >
            <span className="me-2">Lead Status</span>

            <Dropdown
              trigger={["click"]}
              overlay={
                <Menu
                  selectedKeys={[leadStatusFilter]}
                  onClick={({ key }) => setLeadStatusFilter(key as string)}
                  style={{ width: 200 }}
                >
                  <Menu.Item
                    key="all"
                    className="d-flex justify-content-between align-items-center"
                  >
                    <span>
                      <FilterOutlined
                        style={{ marginRight: 8, color: "#4000a6" }}
                      />
                      All
                    </span>
                    <span className="badge bg-light text-dark rounded-pill ms-3">
                      {(leads.length || 0).toLocaleString()}
                    </span>
                  </Menu.Item>

                  <Menu.Item
                    key="Not_Contacted"
                    className="d-flex justify-content-between align-items-center"
                  >
                    <span>
                      <ClockCircleOutlined
                        style={{ marginRight: 8, color: "#fda700" }}
                      />
                      Not Contacted
                    </span>
                    <span className="badge bg-warning-light text-warning rounded-pill ms-3">
                      {statusCounts.Not_Contacted.toLocaleString()}
                    </span>
                  </Menu.Item>

                  <Menu.Item
                    key="Contacted"
                    className="d-flex justify-content-between align-items-center"
                  >
                    <span>
                      <PhoneOutlined
                        style={{ marginRight: 8, color: "#30bc20" }}
                      />
                      Contacted
                    </span>
                    <span className="badge bg-success-light text-success rounded-pill ms-3">
                      {statusCounts.Contacted.toLocaleString()}
                    </span>
                  </Menu.Item>

                  <Menu.Item
                    key="Closed"
                    className="d-flex justify-content-between align-items-center"
                  >
                    <span>
                      <CheckCircleOutlined
                        style={{ marginRight: 8, color: "#1ecbe2" }}
                      />
                      Closed
                    </span>
                    <span className="badge bg-info-light text-info rounded-pill ms-3">
                      {statusCounts.Closed.toLocaleString()}
                    </span>
                  </Menu.Item>

                  <Menu.Item
                    key="Lost"
                    className="d-flex justify-content-between align-items-center"
                  >
                    <span>
                      <CloseCircleOutlined
                        style={{ marginRight: 8, color: "#ff0000" }}
                      />
                      Lost
                    </span>
                    <span className="badge bg-danger-light text-danger rounded-pill ms-3">
                      {statusCounts.Lost.toLocaleString()}
                    </span>
                  </Menu.Item>
                </Menu>
              }
            >
              <ButtonAnt
                size="small"
                type="text"
                onClick={(e) => e.stopPropagation()}
                className="me-1"
              >
                <FunnelPlotFilled
                  style={{
                    fontSize: 15,
                    color: leadStatusFilter !== "all" ? "#1890ff" : "#666",
                  }}
                />
                {leadStatusFilter !== "all" && (
                  <span className="ms-1 small fw-semibold ">
                    {
                      statusCounts[
                      leadStatusFilter as keyof typeof statusCounts
                      ]
                    }
                  </span>
                )}
              </ButtonAnt>
            </Dropdown>
          </div>
        ),
        key: "status",
        render: (_: any, record: Lead) => {
          const status = record.lead_status || "Unknown";

          const statusMap: Record<
            string,
            { icon: string; className: string; label: string }
          > = {
            Not_Contacted: {
              icon: "bi bi-person-x",
              className: "bg-warning",
              label: "Not Contacted",
            },
            Contacted: {
              icon: "bi bi-person-check",
              className: "bg-success",
              label: "Contacted",
            },
            Closed: {
              icon: "bi bi-lock",
              className: "bg-info",
              label: "Closed",
            },
            Lost: {
              icon: "bi bi-person-dash",
              className: "bg-danger",
              label: "Lost",
            },
          };

          const { icon, className, label } = statusMap[status] || {
            icon: "bi bi-question-circle",
            className: "bg-secondary",
            label: status.replace(/_/g, " "),
          };

          return <AnimatedBadge status={status} icon={icon} />;
        },
      },

      owner: {
        title: renderMultiFilterDropdown({
          label: "Lead Owner",
          filterState: filterOwners,
          setFilterState: setFilterOwners,
          uniqueItems: uniqueOwners,
          alphaFilterState: alphaFilterleadowner,
          setAlphaFilterState: setAlphaFilterleadowner,
          searchQuery,
        }),
        key: "owner",
        render: (_: any, record: Lead) => (
          <SubmoduleHoverCard
            name={highlightMatch(record.users?.name, searchQuery)}
            role="Leads"
            email={record.users?.email}      // optional
            phone={record.users?.phone_no}
            contactleadowner_name={record.users?.name}
            dealowner_name={record.users?.name}
            quoteowner_name={record.users?.name}
            createdAt={record.created_at}
            variant2={["contactleadOwner", "dealOwner", "quoteOwner"]}
          />

        ),
      },
      created_at: {
        title: "Created At",
        key: "created_at",
        render: (_: any, record: Lead) => {
          const date = new Date(record.created_at);
          return !isNaN(date.getTime()) ? (
            <div>
              <div>{date.toLocaleDateString()}</div>
              <div style={{ fontSize: "12px", color: "#888" }}>
                {date.toLocaleTimeString()}
              </div>
            </div>
          ) : (
            "N/A"
          );
        },
      },

      updated_at: {
        title: "Updated At",
        key: "updated_at",
        render: (_: any, record: Lead) => {
          const date = new Date(record.updated_at);
          return !isNaN(date.getTime()) ? (
            <div>
              <div>{date.toLocaleDateString()}</div>
              <div style={{ fontSize: "12px", color: "#888" }}>
                {date.toLocaleTimeString()}
              </div>
            </div>
          ) : (
            "N/A"
          );
        },
      },
      lead_type: {
        title: renderMultiFilterDropdown({
          label: "Lead Type",
          filterState: filterLeadTypes,
          setFilterState: setFilterLeadTypes,
          uniqueItems: uniqueLeadTypes,
          alphaFilterState: alphaFilterleadtype,
          setAlphaFilterState: setAlphaFilterleadtype,
          searchQuery,
        }),
        key: "lead_type",
        render: (_: any, record: Lead) => {
          const rawType = record.leadtype?.leadtype_name || "";
          const type = rawType.toLowerCase();
          const iconMap: Record<string, { icon: string; color: string }> = {
            hot: { icon: "bi bi-fire", color: "text-danger" },
            cold: { icon: "bi bi-thermometer-snow", color: "text-info" },
            warm: { icon: "bi bi-thermometer-sun", color: "text-warning" },
            junk: { icon: "bi bi-trash", color: "text-muted" },
            won: { icon: "bi bi-archive", color: "text-success" },
          };
          const defaultIcon = {
            icon: "bi bi-question-circle",
            color: "text-secondary",
          };
          const data = iconMap[type] || defaultIcon;
          return rawType ? (
            <span className="d-flex align-items-center gap-1">
              <i className={`${data.icon} ${data.color}`}></i>
              <span className={data.color}>{rawType}</span>
            </span>
          ) : (
            "N/A"
          );
        },
      },
      lead_source: {
        title: renderMultiFilterDropdown({
          label: "Lead Source",
          filterState: filterLeadSources,
          setFilterState: setFilterLeadSources,
          uniqueItems: uniqueLeadSources,
          alphaFilterState: alphaFilterleadsource,
          setAlphaFilterState: setAlphaFilterleadsource,
          searchQuery,
        }),
        key: "lead_source",
        render: (_: any, record: Lead) =>
          record.leadsource?.LeadSource_name || "N/A",
      },
            leadgivenby_name: {
        title: (
          <div
            className="flex items-center justify-between"
            style={{ height: 28, whiteSpace: "nowrap" }}
            onClick={(e) => e.stopPropagation()} // ← prevents header sort/expand
          >
            <span className="me-2">Leads Given By </span>

            <Dropdown trigger={["click"]} overlay={
        <Menu style={{ width: 220, maxHeight: 300, overflowY: "auto" }} onClick={(e) => e.domEvent.stopPropagation()}>
          <Menu.Item key="all" onClick={(e) => { e.domEvent.stopPropagation(); setFilterLeadGivenBy([]); }}>
            <Checkbox checked={filterLeadGivenBy.length === 0}>All Leads Given By</Checkbox>
          </Menu.Item>
          {Array.from(new Set(leads.map(l => l.leadgiven_by?.LeadGivenBy_name).filter((n): n is string => Boolean(n)))).sort().map(name => {
            const checked = filterLeadGivenBy.includes(name);
            return (
              <Menu.Item key={name} onClick={(e) => { e.domEvent.stopPropagation(); setFilterLeadGivenBy(prev => checked ? prev.filter(v => v !== name) : [...prev, name]); }}>
                <Checkbox checked={checked}>{name}</Checkbox>
              </Menu.Item>
            );
          })}
        </Menu>
      }>
        <ButtonAnt size="small" type="text" style={{ padding: "0 6px" }} onClick={(e) => e.stopPropagation()}>
          <FunnelPlotFilled style={{ fontSize: 15, color: filterLeadGivenBy.length > 0 ? "#1890ff" : "#000" }} />
         
        </ButtonAnt>
      </Dropdown>

            {/* Ant Design Dropdown – pure, tiny, beautiful */}
            <Dropdown
              trigger={["click"]}
              onOpenChange={(open) =>
                open && setTimeout(() => document.body.click(), 0)
              } // optional: close on outside click
              overlay={
                <Menu
                  selectedKeys={
                    alphaFilterleadgiven ? [alphaFilterleadgiven] : ["All"]
                  }
                  onClick={({ key }) =>
                    setAlphaFilterleadgiven(key === "All" ? "" : key)
                  }
                  style={{ width: 50, maxHeight: 250, overflow: "auto" }}
                >
                  <Menu.Item key="All" className="text-center">
                    All
                  </Menu.Item>
                  {Array.from("ABCDEFGHIJKLMNOPQRSTUVWXYZ").map((letter) => (
                    <Menu.Item key={letter} className="text-center">
                      {letter}
                    </Menu.Item>
                  ))}
                </Menu>
              }
            >
              <ButtonAnt
                size="small"
                type="text"
                onClick={(e) => e.stopPropagation()}
                style={{
                  fontSize: 12,
                  height: 17,
                  padding: "0 8px",
                  border: "1px solid #d9d9d9",
                  background: "#fafafa",
                }}
              >
                {alphaFilterleadgiven
                  ? alphaFilterleadgiven.toUpperCase()
                  : "ALL"}
                <DownOutlined style={{ fontSize: 10, marginLeft: 4 }} />
              </ButtonAnt>
            </Dropdown>
          </div>
        ),
        key: "leadgivenby_name",
        render: (_: any, record: Lead) =>
          record.leadgiven_by?.LeadGivenBy_name || "N/A",
      },
      industry: {
        title: renderMultiFilterDropdown({
          label: "Lead Industry",
          filterState: filterIndustries,
          setFilterState: setFilterIndustries,
          uniqueItems: uniqueIndustries,
          alphaFilterState: alphaFilterleadindustry,
          setAlphaFilterState: setAlphaFilterleadindustry,
          searchQuery,
        }),
        key: "industry",
        render: (_: any, record: Lead) =>
          highlightMatch(
            record.leadindustry?.LeadIndustry_name || "N/A",
            searchQuery
          ),
      },
      stage: {
        title: renderMultiFilterDropdown({
          label: "Stage",
          filterState: filterStages,
          setFilterState: setFilterStages,
          uniqueItems: uniqueStages,
          alphaFilterState: alphaFilterleadstage,
          setAlphaFilterState: setAlphaFilterleadstage,
          searchQuery,
        }),
        key: "stage",
        render: (_: any, record: Lead) =>
          highlightMatch(
            record.leadstage?.LeadStage_name || "N/A",
            searchQuery
          ),
      },
      product: {
        title: renderMultiFilterDropdown({
          label: "Course",
          filterState: filterProducts,
          setFilterState: setFilterProducts,
          uniqueItems: uniqueProducts,
          alphaFilterState: alphaFilterproduct,
          setAlphaFilterState: setAlphaFilterproduct,
          searchQuery,
        }),
        key: "product",
        render: (_: any, record: Lead) =>
          highlightMatch(record.products?.product_name || "N/A", searchQuery),
      },
      no_logins: {
        title: "No. of Persons",
        key: "no_logins",
        render: (_: any, record: Lead) => {
          const persons =
            record.no_logins !== undefined && record.no_logins !== null
              ? String(record.no_logins)
              : "";

          return (
            <TextCopy2
              text={persons || "N/A"}
              showPersonIcon
              showText={true}
              showIcon={false} // optional: hide copy icon
            />
          );
        },
      },

      rate_per_login: {
        title: "Rate of Course",
        key: "rate_per_login",
        render: (_: any, record: Lead) => record.rate_per_login || "N/A",
      },
      product_type: {
        title: renderMultiFilterDropdown({
          label: "Course Type",
          filterState: filterProductTypes,
          setFilterState: setFilterProductTypes,
          uniqueItems: uniqueProductTypes,
          alphaFilterState: alphaFilterproducttype,
          setAlphaFilterState: setAlphaFilterproducttype,
          searchQuery,
        }),
        key: "product_type",
        render: (_: any, record: Lead) =>
          record.producttype?.product_name || "N/A",
      },
      customer_potential: {
        title: renderMultiFilterDropdown({
          label: "Customer Potential",
          filterState: filterCustomerPotentials,
          setFilterState: setFilterCustomerPotentials,
          uniqueItems: uniqueCustomerPotentials,
          alphaFilterState: alphaFiltercustomerpotential,
          setAlphaFilterState: setAlphaFiltercustomerpotential,
          searchQuery,
        }),
        key: "customer_potential",
        render: (_: any, record: Lead) =>
          record.customertypes?.customerPotential_name || "N/A",
      },
      contact_description: {
        title: "Contact Description",
        key: "contact_description",
        ellipsis: true,
        render: (_: any, record: Lead) => {
          const value = record.contact?.company_remark || "N/A";

          return (
            <span
              style={{
                display: "inline-block",
                maxWidth: 180,          // 👈 adjust as needed
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {value}
            </span>
          );
        },
      },

      action: {
        title: "Actions",
        key: "action",
        fixed: "right",
        render: (_: any, record: Lead) => {
          const menu = (
            <Menu
              onClick={(e) => e.domEvent.stopPropagation()}
              style={{
                minWidth: 220,
                borderRadius: 8,
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              }}
            >
              <Menu.Item
                key="edit"
                onClick={() => handleShow3(record)}
                className="d-flex align-items-center"
              >
                <i className="ti ti-edit text-primary me-2 fs-15" />
                <span>Edit Lead</span>
              </Menu.Item>
              <Menu.Item
                key="delete"
                data-bs-toggle="modal"
                data-bs-target="#delete_lead"
                onClick={() => setLeadIdToDelete(record.lead_id)}
                className="d-flex align-items-center text-danger"
              >
                <i className="ti ti-trash text-danger me-2 fs-15" />
                <span>Delete Lead</span>
              </Menu.Item>
              <Menu.Divider />
             
              <Menu.Item
                key="view-details"
                onClick={() => {
                  setSelectedLeadForModal(record);
                  setIsDetailsOpen(true);
                }}
                className="d-flex align-items-center"
              >
                <i className="ti ti-eye text-primary me-2 fs-15" />
                <span>view details</span>
              </Menu.Item>
            </Menu>
          );

          return (
            <Dropdown
              overlay={menu}
              trigger={["click"]}
              placement="bottomRight"
              overlayClassName="table-actions-dropdown"
              onOpenChange={(open) => {
                if (open) {
                  // Prevent row click when dropdown opens
                  setTimeout(() => document.body.click(), 0);
                }
              }}
            >
              <ButtonAnt
                size="small"
                type="default"
                className="table-action-btn"
                onClick={(e) => e.stopPropagation()}
              >
                <i className="ti ti-dots-vertical fs-14" />
              </ButtonAnt>
            </Dropdown>
          );
        },
      },
    };

    const handleRowOrderChange = (newOrdered: Lead[]) => {
      setOrderedData(newOrdered);
      // OPTIONAL: persist to backend
      // await reorderLeadSources(newOrdered.map(r => r.LeadSource_id));
    };
    // Handle call initiation
 

    const cols = [
      allColumnsMap.index,
    ];

    // Add columns based on columnKeys order
    columnKeys.forEach((key) => {
      if (visibleColumns[key] && allColumnsMap[key]) {
        cols.push(allColumnsMap[key]);
      }
    });

    if (visibleColumns.action) {
      cols.push(allColumnsMap.action);
    }

    // Separate sticky and non-sticky columns
    const stickyLeft: any[] = [];
    const stickyRight: any[] = [];
    const nonSticky: any[] = [];

    cols.forEach((col) => {
      if (col?.fixed === "left") {
        stickyLeft.push(col);
      } else if (col?.fixed === "right") {
        stickyRight.push(col);
      } else {
        nonSticky.push(col);
      }
    });

    // Sort non-sticky columns by columnKeys order
    const sortedNonSticky = nonSticky.sort((a, b) => {
      const aKey = a.key as string;
      const bKey = b.key as string;
      const aIndex = columnKeys.indexOf(aKey);
      const bIndex = columnKeys.indexOf(bKey);

      // If both are in columnKeys, sort by their order
      if (aIndex !== -1 && bIndex !== -1) {
        return aIndex - bIndex;
      }
      // If only one is in columnKeys, prioritize it
      if (aIndex !== -1) return -1;
      if (bIndex !== -1) return 1;
      // If neither is in columnKeys, maintain original order
      return 0;
    });

    // Combine: sticky left, sorted non-sticky, sticky right
    return [...stickyLeft, ...sortedNonSticky, ...stickyRight];
  }, [
    visibleColumns,
    searchQuery,
    currentPage,
    pageSize,
    handleShow3,
    route.leadsDetails,
    alphaFilter,
    alphaFilterleadowner,
    alphaFilterleadsource,
    alphaFilterleadstage,
    alphaFilterleadtype,
    alphaFilterproduct,
    alphaFilterproducttype,
    columnKeys,
    alphaFilterleadindustry,
    alphaFiltercustomerpotential,
 alphaFilterleadgiven,    leadStatusFilter,
    filterOwners,
    filterLeadSources,
    filterIndustries,
    filterLeadTypes,
    filterStages,
    filterProducts,
    filterProductTypes,
    filterCustomerPotentials,
  ]);


  // Handle call initiation
  const handleCallNow = async (lead_id: string) => {
    try {
      await makeCallToLead(lead_id);
      toast.success("Call successfully initiated ");
    } catch (error) {
      console.error("Error initiating call:", error);
      toast.error("Failed to initiate call ");
    }
  };

  const Currency = useMemo(
    () => [
      { value: "INR", label: "INR" },
      { value: "Dollar", label: "Dollar" },
      { value: "Euro", label: "Euro" },
      { value: "Pound", label: "Pound" },
    ],
    []
  );

  const leadStatusOptions = useMemo(
    () => [
      { value: "Contacted", label: "Contacted" },
      { value: "Not_Contacted", label: "Not Contacted" },
      { value: "Closed", label: "Closed" },
      { value: "Lost", label: "Lost" },
    ],
    []
  );

  const [formData, setFormData] = useState<CreateLeadPayload>({
    leadindustry_id: "",
    leadowner_id: "",
    leadsource_id: "",
    leadtype_id: "",
    product_id: "",
    website_url: "",
    lead_value: "",
    Currency: "INR",
    lead_status: "",
    leadstage_id: "",
    lead_description: "",
    contact_id: "",
    branch_id: "",
    leadgivenby_id: "",
    migrating_from: "",
  });

  const handleInputChange = useCallback(
    (field: keyof CreateLeadPayload, value: string) => {
      setFormData((prev) => ({ ...prev, [field]: value }));
    },
    []
  );

  const handleSubmit = async () => {
    try {
      const { branch_id, ...restFormData } = formData;

      const payload = {
        ...restFormData,
        ...(selectedBranch?.branch_id
          ? { branch_id: selectedBranch.branch_id }
          : {}),
      };

      // 🔍 Check for duplicate
      const isDuplicate = leads.some(
        (lead) =>
          lead.contact?.contact_id === payload.contact_id &&
          lead.branch_id === payload.branch_id
      );

      if (isDuplicate) {
        toast.error("A lead for this company and branch already exists.");
        return;
      }

      // ✅ Basic field validation
      if (!payload.contact_id) return toast.error("Company name is required.");
      // if (!payload.branch_id) return toast.error("Branch is required.");
      if (!payload.leadsource_id)
        return toast.error("Lead Source is required.");
      //if (!payload.leadindustry_id) return toast.error("Lead Business Type is required.");
      if (!payload.leadtype_id) return toast.error("Lead Type is required.");
      if (!payload.leadstage_id) return toast.error("Lead Stage is required.");
      if (!payload.product_id) return toast.error("Product is required.");
      if (!payload.product_type_id)
        return toast.error("Product Type is required.");
      if (!payload.customerPotential_id)
        return toast.error("Customer Potential is required.");
      //if (!payload.lead_value) return toast.error("Quoted Value is required.");
      if (!payload.Currency) return toast.error("Currency is required.");
      if (!payload.lead_status) return toast.error("Lead Status is required.");
      if (!payload.leadowner_id)
        return toast.error("Assign To (User) is required.");
      if (!payload.leadgivenby_id)
        return toast.error("Lead Given By is required.");

      // ✅ Proceed with lead creation
      await createLead(payload);
      toast.success("Lead created successfully");
      //setOpenModal2(true);
      // 🔄 Reset form
      setFormData({
        leadindustry_id: "",
        leadowner_id: "",
        leadsource_id: "",
        leadtype_id: "",
        product_id: "",
        product_type_id: "",
        customerPotential_id: "",
        website_url: "",
        lead_value: "",
        Currency: "",
        lead_status: "",
        leadstage_id: "",
        lead_description: "",
        contact_id: "",
        branch_id: "",
      });

      setSelectedBranch(null);
      setSelectedCompany(null);
      handleClose2();
      await refreshLeads();
    } catch (error: any) {
      toast.error(`Error: ${error.message}`);
      console.error("Submission Error:", error);
    }
  };

  const companyOptions = useMemo(
    () =>
      [...companies]
        .reverse() // most recent first
        .map((c) => ({
          label: `${c.company.company_name} (${c.company.contact_person_name})`,
          value: c.company.contact_id,
          fullCompany: c,
        })),
    [companies]
  );

  const handleCompanyChange = useCallback((selected: any) => {
    const company: CompanyWithBranches = selected.fullCompany;
    setSelectedCompany(company);
    setSelectedBranch(null); // reset previous branch
    if (!company.company.leadowner_id) {
      toast.info(
        "Assign To(Lead Owner) not found for this company. Please select manually."
      );
    }

    if (company?.company) {
      setFormData((prev) => ({
        ...prev,
        contact_id: company.company.contact_id,
        website_url: company.company.website_url || "",
        contact_mail: company.company.company_mail || "",
        leadowner_id: company.company.leadowner_id || "",
        leadsource_id: company.company.leadsource_id || "",
        leadgivenby_id: company.company.leadgivenby_id || "",
      }));
    }
  }, []);

  const handleEditCompanyChange = useCallback((selected: any) => {
    const company: CompanyWithBranches = selected.fullCompany;
    setSelectedCompany(company);

    if (company?.company) {
      setEditLeadFormData((prev) => ({
        ...prev,
        contact_id: company.company.contact_id,
        contact_Company_name: company.company.company_name || "",
        contact_name: company.company.contact_person_name || "",
        contact_phone: company.company.company_phone || "",
        website_url: company.company.website_url || "",
        leadgivenby_id: company.company.leadgivenby_id || "",
      }));
    }
  }, []);
  // Export All Leads - PDF
  const handleExportAllLeadsPDF = useCallback(async () => {
    if (leads.length === 0) {
      toast.warning("No leads available to export pdf.");
      return;
    }
    try {
      const response = await exportLeadsPDF();
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `All_Leads.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err: any) {
      console.error("Failed to export all leads as PDF");
    }
  }, [leads]);

  // Export All Leads - Excel
  const handleExportAllLeadsExcel = useCallback(async () => {
    if (leads.length === 0) {
      toast.warning("No leads available to export excel.");
      return;
    }
    try {
      const response = await exportLeadsExcel();
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `All_Leads.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err: any) {
      console.error("Failed to export all leads as Excel");
    }
  }, [leads]);

  // Export Selected Leads
  const handleExportSelectedLeadsPDF = useCallback(
    async (leadIds: string[]) => {
      if (leadIds.length === 0) {
        toast.warning("Please select at least one lead to export pdf.");
        return;
      }
      try {
        const response = await exportSelectedLeadsPDF(leadIds);
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Selected_Leads.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (err: any) {
        console.error("Failed to export selected leads as PDF");
      }
    },
    []
  );

  const handleExportSelectedLeadsExcel = useCallback(
    async (leadIds: string[]) => {
      if (leadIds.length === 0) {
        toast.warning("Please select at least one lead to export excel.");
        return;
      }
      try {
        const response = await exportSelectedLeadsExcel(leadIds);
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Selected_Leads.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (err: any) {
        console.error("Failed to export selected leads as Excel");
      }
    },
    []
  );


  const handleRowOrderChange = (newOrdered: Lead[]) => {
    setOrderedData(newOrdered);
    // OPTIONAL: persist to backend
    // await reorderLeadSources(newOrdered.map(r => r.LeadSource_id));
  };
  // State for export modal, format, and selected columns
  const [showExportModal, setShowExportModal] = useState(false);

  useEffect(() => {
    if (showExportModal) {
      setTimeout(() => {
        const modalElement = document.getElementById("custom_export_modal");
        if (modalElement) {
          setupDraggable(modalElement);
        }
      }, 100);
    }
  }, [showExportModal]);

  const [exportFormat, setExportFormat] = useState<"excel" | "pdf">("excel");
  const [selectedColumns, setSelectedColumns] = useState<string[]>([]); // Default to commonly used columns

  // Column mappings for selection
  const exportColumns = [
    { key: "company_name", label: "Client Name" },
    { key: "contact_person_name", label: "Contact Person" },
    { key: "lead_value", label: "Lead Value" },
    { key: "lead_status", label: "Lead Status" },
    { key: "lead_description", label: "Lead Description" },
    { key: "currency", label: "Currency" },
    { key: "no_logins", label: "No. of Persons" },
    { key: "rate_per_login", label: "Rate of Course" },
    { key: "tax", label: "Tax (%)" },
    { key: "amount", label: "Amount" },
    { key: "total_amount", label: "Total Amount" },
    { key: "proposal_discount", label: "Proposal Discount" },
    { key: "proposal_discount_percentage", label: "Discount (%)" },
    { key: "proposal_tax_percentage", label: "Tax (%)" },
    { key: "quotation_id", label: "Quotation ID" },
    { key: "created_at", label: "Created At" },
    { key: "updated_at", label: "Updated At" },
    { key: "lead_owner_name", label: "Lead Owner" },
    { key: "lead_source_name", label: "Lead Source" },
    { key: "lead_industry_name", label: "Industry" },
    { key: "lead_stage_name", label: "Lead Stage" },
    { key: "lead_type_name", label: "Lead Type" },
    { key: "customer_type_name", label: "Customer Type" },
    { key: "product_name", label: "Product Name" },
    { key: "product_type_name", label: "Product Type" },
  ];

  // Handlers
  const handleShowExportModal = useCallback(() => {
    if (selectedLeads.length === 0) {
      toast.warning("Please select at least one lead for customized export.");
      return;
    }
    setShowExportModal(true);
  }, [selectedLeads.length]);

  const handleCloseExportModal = () => setShowExportModal(false);

  const handleColumnSelect = useCallback((key: string) => {
    setSelectedColumns((prev) =>
      prev.includes(key) ? prev.filter((col) => col !== key) : [...prev, key]
    );
  }, []);

  const hasSelectedColumn = selectedColumns.length > 0;
  const allColumnsSelected = selectedColumns.length === exportColumns.length;

  const handleExportSubmit = useCallback(
    async (format: "pdf" | "excel") => {
      if (selectedColumns.length === 0) {
        toast.warning("Please select at least one column to export.");
        return;
      }
      try {
        await exportLeadsReport({
          leadIds: selectedLeads,
          fields: selectedColumns, // selected column keys
          format, // ✅ USE BUTTON FORMAT
        });
        toast.success(
          `Leads exported successfully as ${exportFormat.toUpperCase()}`
        );
        handleCloseExportModal();
      } catch (err) {
        console.error("Export error:", err);
      }
    },
    [selectedColumns, selectedLeads, exportFormat]
  );

  const handlePaginationChange = useCallback((page: number, size: number) => {
    setCurrentPage(page);
    setPageSize(size);
  }, []);

  const handleRowSelectionChange = useCallback(
    (selectedRowKeys: React.Key[]) => {
      setSelectedLeads(selectedRowKeys.map(String));
    },
    []
  );

  const tableConfig = useMemo(
    () => ({
      dataSource: filteredAndSortedLeads,
      columns,
      className: "custom-table",
      rowKey: "lead_id",
      loading: reduxReLeadsLoading,
      rowSelection: {
        selectedRowKeys: selectedLeads,
        onChange: handleRowSelectionChange,
      },
      rowClassName: (record: Lead) => {
        if (!showRowStatus) return "";
        const status = record.lead_status?.toLowerCase().replace(/\s|_/g, "-");
        return status ? `row-status-${status}` : "";
      },
      pagination: {
        current: currentPage,
        pageSize: pageSize,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50"],
        onChange: handlePaginationChange,
      },
      draggable: true, // <-- ENABLE
      onRowOrderChange: handleRowOrderChange,
      scroll: { x: "max-content" } as const,
      components: {
        header: {
          cell: (props: any) => (
            <th
              {...props}
              style={{
                ...props.style,
                position: "sticky",
                top: 0,
                zIndex: 2,
                background: "#fff",
                boxShadow: "inset 0 -1px 0 #f50e0e", // ✅ subtle clean line
              }}
            />
          ),
        },
        body: {
          row: (props: any) => {
            const record = props["data-row-key"];
            const status = record?.lead_status;
            const statusClass =
              showRowStatus && status
                ? `row-status-${status.toLowerCase().replace(/\s|_/g, "-")}`
                : "";
            return (
              <tr
                {...props}
                className={`${props.className || ""} ${statusClass}`}
                title={
                  showRowStatus && status
                    ? `Status: ${status.replace(/_/g, " ")}`
                    : undefined
                }
              />
            );
          },
        },
      },
    }),
    [
      filteredAndSortedLeads,
      columns,
      reduxReLeadsLoading,
      selectedLeads,
      currentPage,
      pageSize,
      showRowStatus,
      handleRowSelectionChange,
      handlePaginationChange,
      handleRowOrderChange,
    ]
  );

  const editContributorIds = useMemo(
    () => selectedContributors.map((c) => c.value).join(","),
    [selectedContributors]
  );

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedSearchQuery(searchQuery), 300);
    return () => clearTimeout(timer);
  }, [searchQuery]);

  return (
    <>
      <>
        <PageLoadProgressBar />
        {/* Page Wrapper */}
        <div className="page-wrapper">
         <div className="content">
          <div className="row">
            <div className="col-md-12">
              {/* Page Header */}
              <div className="page-header mb-0">
                <div className="row align-items-center">
                  <div className="col-4">
                    <h4 className="page-title">
                      <i className="ti ti-chart-arcs text-primary me-2" />
                      Leads
                      <span className="count-title">
                        <CountUp
                          end={leads.length}
                          duration={3.0}
                          separator=","
                        />
                      </span>
                    </h4>
                  </div>
                  <div className="col-8 text-end">
                    <div className="head-icons">
                      <CollapseHeader />
                    </div>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
              {/* Breadcrumb */}
              <nav
                aria-label="breadcrumb"
                className="page-header-breadcrumb mb-3"
              >
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link
                      to={
                        userRole === "admin"
                          ? route.dealsDashboard
                          : route.leadsDashboard
                      }
                      style={{
                        color: "#9595b5",
                        textDecoration: "none",
                        transition: "color 0.2s ease",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.color = "#E41F07")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.color = "#9595b5")
                      }
                    >
                      Dashboard
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Leads
                  </li>
                </ol>
              </nav>
              {/* /Breadcrumb */}
              <div className="card">
                <div className="card-header">
                  {/* Search */}
                  <div className="row align-items-center">
                    <div className="col-xl-5 col-lg-6 col-md-6 col-12 mb-3 mb-md-0">
                      <div className="d-flex align-items-center gap-3">
                        <div className="icon-form position-relative mb-0 flex-grow-1 ms-3">
                        <span className="form-icon">
                          <i className="ti ti-search" />
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search Leads ..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          style={{
                            paddingRight: searchQuery ? "60px" : "15px", // make space for clear button
                          }}
                        />

                        {/* Clear button - appears only when there's text */}
                        {searchQuery && (
                          <button
                            type="button"
                            className="position-absolute end-0 top-50 translate-middle-y me-3 text-muted"
                            style={{
                              zIndex: 10,
                              background: "none",
                              border: "none",
                              width: "30px",
                              height: "30px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                            onClick={() => setSearchQuery("")}
                            aria-label="Clear search"
                          >
                            <i className="ti ti-x fs-16" />
                          </button>
                        )}
                      </div>
                       
                    </div>
                   </div>
                    <div className="col-xl-7 col-lg-6 col-md-6 col-12">
                      <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
                        <Form.Check
                            type="switch"
                            id="toggle-row-status"
                            label="Show Row Status"
                            checked={showRowStatus}
                            onChange={(e) => setShowRowStatus(e.target.checked)}
                            className="ms-3 me-2"
                          />
                        <SequentialHighlight>
                          {userRole === "admin" && (
                            <Link
                              to={route.leadsInsights}
                              className="btn btn-outline-warning me-2 mb-0"
                            >
                              <i className="ti ti-graph me-2" />
                              Leads Insights
                            </Link>
                          )}
                        </SequentialHighlight>
                        <div className="dropdown me-2">
                          <button
                            type="button"
                            className={`btn btn-outline-secondary d-flex align-items-center gap-2 dropdown-toggle ${selectedLeads.length > 0 ? "border-primary text-primary" : ""
                              }`}
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            disabled={loading}
                          >
                            <i className="ti ti-package-export fs-16" />
                            <span className="d-none d-sm-inline">Export</span>
                            {selectedLeads.length > 0 && (
                              <span className="badge bg-primary rounded-pill ms-2">
                                {selectedLeads.length}
                              </span>
                            )}
                          </button>

                          <ul
                            className="dropdown-menu dropdown-menu-end shadow-lg border-0 py-3 px-2"
                            style={{ minWidth: "260px" }}
                          >
                            {/* Header */}
                            <li>
                              <div className="px-3 mb-2">
                                <small className="text-uppercase text-muted fw-bold">
                                  Export Options
                                </small>
                              </div>
                            </li>

                            {/* Export All */}
                            <li>
                              <hr className="dropdown-divider my-1" />
                            </li>
                            <li>
                              <div className="px-3 py-1">
                                <small className="text-muted">
                                  All Records ({leads.length}) {/* or filteredLeads.length if you have filtering */}
                                </small>
                              </div>
                            </li>
                            <li>
                              <button
                                className="dropdown-item d-flex align-items-center gap-3 py-2 rounded-3"
                                onClick={handleExportAllLeadsPDF}
                              >
                                <div className="avatar avatar-sm bg-danger-light rounded">
                                  <i className="ti ti-file-type-pdf text-danger fs-14" />
                                </div>
                                <div className="text-start">
                                  <div className="fw-medium">Export as PDF</div>
                                  <small className="text-muted">Portable Document Format</small>
                                </div>
                              </button>
                            </li>
                            <li>
                              <button
                                className="dropdown-item d-flex align-items-center gap-3 py-2 rounded-3"
                                onClick={handleExportAllLeadsExcel}
                              >
                                <div className="avatar avatar-sm bg-success-light rounded">
                                  <i className="ti ti-file-spreadsheet text-success fs-14" />
                                </div>
                                <div className="text-start">
                                  <div className="fw-medium">Export as Excel</div>
                                  <small className="text-muted">Spreadsheet (.xlsx)</small>
                                </div>
                              </button>
                            </li>

                            {/* Export Selected */}
                            {selectedLeads.length > 0 && (
                              <>
                                <li>
                                  <hr className="dropdown-divider my-2" />
                                </li>
                                <li>
                                  <div className="px-3 py-1">
                                    <small className="text-muted">
                                      Selected Only ({selectedLeads.length})
                                    </small>
                                  </div>
                                </li>
                                <li>
                                  <button
                                    className="dropdown-item d-flex align-items-center gap-3 py-2 rounded-3"
                                    onClick={() => handleExportSelectedLeadsPDF(selectedLeads)}
                                  >
                                    <div className="avatar avatar-sm bg-danger-light rounded">
                                      <i className="ti ti-file-type-pdf text-danger fs-14" />
                                    </div>
                                    <div className="text-start">
                                      <div className="fw-medium">Export Selected as PDF</div>
                                    </div>
                                  </button>
                                </li>
                                <li>
                                  <button
                                    className="dropdown-item d-flex align-items-center gap-3 py-2 rounded-3"
                                    onClick={() => handleExportSelectedLeadsExcel(selectedLeads)}
                                  >
                                    <div className="avatar avatar-sm bg-success-light rounded">
                                      <i className="ti ti-file-spreadsheet text-success fs-14" />
                                    </div>
                                    <div className="text-start">
                                      <div className="fw-medium">Export Selected as Excel</div>
                                    </div>
                                  </button>
                                </li>
                              </>
                            )}

                            {/* Custom Export */}
                            <li>
                              <hr className="dropdown-divider my-2" />
                            </li>
                            <li>
                              <button
                                className="dropdown-item d-flex align-items-center gap-3 py-2 rounded-3"
                                onClick={handleShowExportModal}
                              >
                                <div className="avatar avatar-sm bg-warning-light rounded">
                                  <i className="ti ti-file-settings text-warning fs-14" />
                                </div>
                                <div className="text-start">
                                  <div className="fw-medium">Custom Export</div>
                                  <small className="text-muted">Select columns & format</small>
                                </div>
                              </button>
                            </li>

                            {/* No selection hint */}
                            {selectedLeads.length === 0 && (
                              <li>
                                <div className="text-center py-4 px-3">
                                  <i className="ti ti-checkbox fs-32 text-muted d-block mb-2" />
                                  <small className="text-muted">
                                    Select rows to export specific records
                                  </small>
                                </div>
                              </li>
                            )}
                          </ul>
                        </div>
                        <button
                          type="button"
                          className="btn btn-primary me-3"
                          onClick={handleShow2}
                          style={{
                            position: "relative",
                            overflow: "hidden",
                             whiteSpace: "nowrap"
                          }}
                        >
                          <i
                            className="ti ti-square-rounded-plus me-2"
                            style={{ position: "relative", zIndex: 2 }}
                          />
                          <span style={{ position: "relative", zIndex: 2 }}>
                           Add Leads
                          </span>
                          <span
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                              background:
                                "linear-gradient(to right, transparent 0%, rgba(255, 255, 255, 0.4) 50%, transparent 100%)",
                              transform: "skewX(-20deg) translateX(-150%)",
                              animation: "shine 3s infinite",
                            }}
                          />
                        </button>
                      </div>
                      
                        {/* <Link
                            to="#"
                            className="btn btn-primary"
                            onClick={handleShow2}
                          >
                            <i className="ti ti-square-rounded-plus me-2" />
                            Add Leads
                          </Link> */}

                    </div>
                  </div>

                  {/* /Search */}
                </div>
              <div className="card-body">
                  {/* Filter */}
                  <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-4">
                    <div className="d-flex align-items-center flex-wrap row-gap-2">
                      <div className="dropdown me-2">
                        <Link
                          to="#"
                          className="dropdown-toggle dropdown-active-toggle common-sort-dropdown-toggle"
                          data-bs-toggle="dropdown"
                        >
                          <i className="ti ti-sort-ascending-2 me-2" />
                          Sort
                        </Link>
                        <div
                          className="dropdown-menu dropdown-menu-start"
                          style={{
                            minWidth: "240px",
                            maxWidth: "300px",
                            whiteSpace: "normal",
                          }}
                        >
                          <ul>
                            {[
                              { label: "Ascending", value: "ascending" },
                              { label: "Descending", value: "descending" },
                              {
                                label: "Recently Added",
                                value: "recently_added",
                              },
                              // {
                              //   label: "Recently Viewed",
                              //   value: "recently_viewed",
                              // },
                            ].map(({ label, value }) => {
                              const isActive = sortOption === value;
                              return (
                                <li key={value}>
                                  <Link
                                    to="#"
                                    className={`dropdown-item d-flex justify-content-between align-items-center ${isActive ? "fw-bold text-primary" : ""
                                      }`}
                                    style={{
                                      whiteSpace: "normal",
                                      wordWrap: "break-word",
                                    }}
                                    onClick={() => setSortOption(value)}
                                  >
                                    <span>
                                      <i className="ti ti-circle-chevron-right me-1" />
                                      {label}
                                    </span>
                                    <div className="d-flex align-items-center mt-1 mt-sm-0">
                                      {isActive && (
                                        <i className="ti ti-check" />
                                      )}
                                    </div>
                                  </Link>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      </div>
                      <div className="dropdown me-2">
                        <Link
                          to="#"
                          className="dropdown-toggle dropdown-active-toggle common-sort-dropdown-toggle"
                          data-bs-toggle="dropdown"
                        >
                          <i className="ti ti-filter-check me-2" />
                          Lead Status
                        </Link>
                        <div
                          className="dropdown-menu dropdown-menu-start"
                          style={{
                            minWidth: "240px",
                            maxWidth: "300px",
                            whiteSpace: "normal",
                          }}
                        >
                          <ul className="list-unstyled mb-0">
                            {/* ALL Option */}
                            <li>
                              <Link
                                to="#"
                                className={`dropdown-item d-flex justify-content-between align-items-start flex-wrap ${activeLeadStatusTab === null
                                  ? "fw-bold text-primary"
                                  : ""
                                  }`}
                                style={{ wordWrap: "break-word" }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  setActiveLeadStatusTab(null);
                                }}
                              >
                                <span className="d-flex align-items-center">
                                  <i className="ti ti-circle-dot me-1" />
                                  All
                                </span>
                                <div className="d-flex align-items-center">
                                  <span className="badge bg-light text-dark border">
                                    {Object.values(statusCounts).reduce(
                                      (acc, count) => acc + count,
                                      0
                                    )}
                                  </span>
                                  {activeLeadStatusTab === null && (
                                    <i className="ti ti-check ms-2 text-success" />
                                  )}
                                </div>
                              </Link>
                            </li>

                            {/* Individual Status Options */}
                            {leadStatusTabs.map(({ key, label }) => {
                              const isActive = activeLeadStatusTab === key;
                              return (
                                <li key={key}>
                                  <Link
                                    to="#"
                                    className={`dropdown-item status-dropdown-item d-flex justify-content-between align-items-start flex-wrap ${isActive ? 
                                      "active" : 
                                      "text-dark hover-bg-light"
                                      }`}
                                    style={{
                                      whiteSpace: "normal",
                                      wordWrap: "break-word",
                                    }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setActiveLeadStatusTab((prev) =>
                                        prev === key ? null : key
                                      );
                                    }}
                                  >
                                    <span className="d-flex align-items-center">
                                      <i className="ti ti-circle-chevron-right me-1" />
                                      {label}
                                    </span>
                                    <div className="d-flex align-items-center mt-1 mt-sm-0">
                                      <span className="badge bg-light text-dark border">
                                        {statusCounts[key] || 0}
                                      </span>
                                      {isActive && (
                                        <i className="ti ti-check ms-2 text-success" />
                                      )}
                                    </div>
                                  </Link>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      </div>

                      <div className="icon-form">
                        <span className="form-icon">
                          <i className="ti ti-calendar" />
                        </span>
                        <DateRangePicker
                          initialSettings={initialSettings}
                          onCallback={(start, end, label) => {
                            setSelectedDateRange([
                              start.toDate(),
                              end.toDate(),
                            ]);
                            if (label) setActiveRangeLabel(label); // track selected label
                          }}
                        >
                          <input
                            className="form-control bookingrange"
                            type="text"
                            readOnly
                          />
                        </DateRangePicker>
                      </div>
                    </div>
                    <div className="d-flex align-items-center flex-wrap row-gap-2">
                      {selectedLeads.length > 0 && (
                        <button
                          className="btn btn-outline-danger me-2 mb-0 d-flex align-items-center"
                          onClick={() => setShowBulkDeleteModal(true)}
                        >
                          <i className="ti ti-trash-x me-2" />
                          Bulk Delete ({selectedLeads.length})
                        </button>
                      )}

                      <div className="dropdown me-2">
                        <Link
                          to="#"
                          className="btn bg-soft-purple text-purple"
                          data-bs-toggle="dropdown"
                          data-bs-auto-close="outside"
                        >
                          <i className="ti ti-columns-3 me-2" />
                          Manage Columns
                        </Link>
                        <div className="dropdown-menu  dropdown-menu-md-end dropdown-md p-3">
                          <h4 className="mb-2 fw-semibold">
                            Want to manage datatables?
                          </h4>
                          <p className="mb-3">
                            Please drag and drop your column to reorder your
                            table and enable see option as you want.
                          </p>
                          <div className="border-top pt-3">
                            <ColumnManagement
                              columnKeys={columnKeys}
                              visibleColumns={visibleColumns}
                              onColumnOrderChange={setColumnKeys}
                              onColumnToggle={(key) => {
                                setVisibleColumns((prev) => ({
                                  ...prev,
                                  [key]: !prev[key],
                                }));
                              }}
                              fixedKeys={["action", "lead_name"]}
                              labels={columnLabels}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-sorts dropdown me-2">
                        <Link
                          to="#"
                          className="dropdown-toggle dropdown-active-toggle common-filter-btn"
                          data-bs-toggle="dropdown"
                          data-bs-auto-close="outside"
                        >
                          <i className="ti ti-filter-share" />
                          Filter
                          {(filterNames.length > 0 ||
                            filterCompanies.length > 0 ||
                            filterStatuses.length > 0 ||
                            filterOwners.length > 0 ||
                            filterLeadTypes.length > 0 ||
                            filterLeadSources.length > 0 ||
                            filterIndustries.length > 0 ||
                            filterStages.length > 0 ||
                            filterProducts.length > 0 ||
                            filterProductTypes.length > 0 ||
                            filterCustomerPotentials.length > 0) && (
                              <span className="badge bg-primary rounded-pill ms-2 filter-btn-badge">
                                {filterNames.length +
                                  filterCompanies.length +
                                  filterStatuses.length +
                                  filterOwners.length +
                                  filterLeadTypes.length +
                                  filterLeadSources.length +
                                  filterIndustries.length +
                                  filterStages.length +
                                  filterProducts.length +
                                  filterProductTypes.length +
                                  filterCustomerPotentials.length}
                              </span>
                            )}
                        </Link>
                        <div className="filter-dropdown-menu dropdown-menu dropdown-menu-md-end p-3">
                          <div className="filter-set-view">
                            <div className="filter-set-head">
                              <h4>
                                <i className="ti ti-filter-share" />
                                Filter
                              </h4>
                            </div>
                            <div className="accordion" id="accordionExample">
                              {/* Leads Name */}
                              <div className="filter-set-content">
                                <div className="filter-set-content-head d-flex align-items-center gap-2">
                                  <Link
                                    to="#"
                                    className={`filter-accordion-link ${
                                      openAccordion === "collapseTwo"
                                        ? ""
                                        : "collapsed"
                                    }`}
                                    onClick={() =>
                                      handleAccordionToggle("collapseTwo")
                                    }
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseTwo"
                                  >
                                    Leads Name
                                    {/* <i
                                      className={`ti ${
                                        openAccordion === "collapseTwo"
                                          ? "ti-chevron-up"
                                          : "ti-chevron-down"
                                      } ms-2`}
                                    /> */}
                                  </Link>
                                  {filterNames.length > 0 && (
                                    <span className="badge bg-primary rounded-pill small">
                                      {filterNames.length}
                                    </span>
                                  )}
                                </div>
                                {openAccordion === "collapseTwo" && (
                                  <div
                                    className="filter-set-contents accordion-collapse collapse show"
                                    id="collapseTwo"
                                  >
                                    <div className="filter-content-list">
                                      <div className="mb-2 icon-form">
                                        <span className="form-icon">
                                          <i className="ti ti-search" />
                                        </span>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Search Leads Name"
                                          value={filterNamesSearch}
                                          onChange={(e) =>
                                            setFilterNamesSearch(e.target.value)
                                          }
                                        />
                                      </div>
                                      {uniqueNames
                                        .filter((n) =>
                                          n
                                            .toLowerCase()
                                            .includes(
                                              filterNamesSearch.toLowerCase()
                                            )
                                        )
                                        .map((name) => (
                                          <li key={name}>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input
                                                  type="checkbox"
                                                  checked={filterNames.includes(
                                                    name
                                                  )}
                                                  onChange={() =>
                                                    handleFilterChange(
                                                      name,
                                                      filterNames,
                                                      setFilterNames
                                                    )
                                                  }
                                                />
                                                <span className="checkmarks" />{" "}
                                                {name}
                                              </label>
                                            </div>
                                          </li>
                                        ))}
                                      {uniqueNames.filter((n) =>
                                        n
                                          .toLowerCase()
                                          .includes(
                                            filterNamesSearch.toLowerCase()
                                          )
                                      ).length === 0 && (
                                          <p className="text-muted px-2">
                                            No data found
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                )}
                              </div>
                              <hr className="my-2" />
                              {/* Company Name */}
                              <div className="filter-set-content">
                                <div className="filter-set-content-head d-flex align-items-center gap-2">
                                  <Link
                                    to="#"
                                    className={`filter-accordion-link ${
                                      openAccordion === "company"
                                        ? ""
                                        : "collapsed"
                                    }`}
                                    onClick={() =>
                                      handleAccordionToggle("company")
                                    }
                                  >
                                    Company Name
                                    {/* <i
                                      className={`ti ${
                                        openAccordion === "company"
                                          ? "ti-chevron-up"
                                          : "ti-chevron-down"
                                      } ms-2`}
                                    /> */}
                                  </Link>
                                  {filterCompanies.length > 0 && (
                                    <span className="badge bg-primary rounded-pill small">
                                      {filterCompanies.length}
                                    </span>
                                  )}
                                </div>
                                {openAccordion === "company" && (
                                  <div className="filter-set-contents accordion-collapse">
                                    <div className="filter-content-list">
                                      <div className="mb-2 icon-form">
                                        <span className="form-icon">
                                          <i className="ti ti-search" />
                                        </span>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Search Company Name"
                                          value={filterCompaniesSearch}
                                          onChange={(e) =>
                                            setFilterCompaniesSearch(
                                              e.target.value
                                            )
                                          }
                                        />
                                      </div>
                                      {uniqueCompanies
                                        .filter((n) =>
                                          n
                                            .toLowerCase()
                                            .includes(
                                              filterCompaniesSearch.toLowerCase()
                                            )
                                        )
                                        .map((company) => (
                                          <li key={company}>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input
                                                  type="checkbox"
                                                  checked={filterCompanies.includes(
                                                    company
                                                  )}
                                                  onChange={() =>
                                                    handleFilterChange(
                                                      company,
                                                      filterCompanies,
                                                      setFilterCompanies
                                                    )
                                                  }
                                                />
                                                <span className="checkmarks" />{" "}
                                                {company}
                                              </label>
                                            </div>
                                          </li>
                                        ))}
                                      {uniqueCompanies.filter((n) =>
                                        n
                                          .toLowerCase()
                                          .includes(
                                            filterCompaniesSearch.toLowerCase()
                                          )
                                      ).length === 0 && (
                                          <p className="text-muted px-2">
                                            No data found
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                )}
                              </div>
                              <hr className="my-2" />
                              {/* Lead Status */}
                              <div className="filter-set-content">
                                <div className="filter-set-content-head d-flex align-items-center gap-2">
                                  <Link
                                    to="#"
                                    className={`filter-accordion-link ${
                                      openAccordion === "status"
                                        ? ""
                                        : "collapsed"
                                    }`}
                                    onClick={() =>
                                      handleAccordionToggle("status")
                                    }
                                  >
                                    Lead Status
                                    {/* <i
                                      className={`ti ${
                                        openAccordion === "status"
                                          ? "ti-chevron-up"
                                          : "ti-chevron-down"
                                      } ms-2`}
                                    /> */}
                                  </Link>
                                  {filterStatuses.length > 0 && (
                                    <span className="badge bg-primary rounded-pill small">
                                      {filterStatuses.length}
                                    </span>
                                  )}
                                </div>
                                {openAccordion === "status" && (
                                  <div className="filter-set-contents accordion-collapse">
                                    <div className="filter-content-list">
                                      <div className="mb-2 icon-form">
                                        <span className="form-icon">
                                          <i className="ti ti-search" />
                                        </span>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Search Lead Status"
                                          value={filterStatusesSearch}
                                          onChange={(e) =>
                                            setFilterStatusesSearch(
                                              e.target.value
                                            )
                                          }
                                        />
                                      </div>
                                      {uniqueStatuses
                                        .filter((n) =>
                                          n
                                            .toLowerCase()
                                            .includes(
                                              filterStatusesSearch.toLowerCase()
                                            )
                                        )
                                        .map((status) => (
                                          <li key={status}>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input
                                                  type="checkbox"
                                                  checked={filterStatuses.includes(
                                                    status
                                                  )}
                                                  onChange={() =>
                                                    handleFilterChange(
                                                      status,
                                                      filterStatuses,
                                                      setFilterStatuses
                                                    )
                                                  }
                                                />
                                                <span className="checkmarks" />{" "}
                                                {status}
                                              </label>
                                            </div>
                                          </li>
                                        ))}
                                      {uniqueStatuses.filter((n) =>
                                        n
                                          .toLowerCase()
                                          .includes(
                                            filterStatusesSearch.toLowerCase()
                                          )
                                      ).length === 0 && (
                                          <p className="text-muted px-2">
                                            No data found
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                )}
                              </div>

                              <hr className="my-2" />

                              {/* Lead Owner */}
                              <div className="filter-set-content">
                                <div className="filter-set-content-head d-flex align-items-center gap-2">
                                  <Link
                                    to="#"
                                    className={`filter-accordion-link ${
                                      openAccordion === "owner"
                                        ? ""
                                        : "collapsed"
                                    }`}
                                    onClick={() =>
                                      handleAccordionToggle("owner")
                                    }
                                  >
                                    Lead Owner
                                    {/* <i
                                      className={`ti ${
                                        openAccordion === "owner"
                                          ? "ti-chevron-up"
                                          : "ti-chevron-down"
                                      } ms-2`}
                                    /> */}
                                  </Link>
                                  {filterOwners.length > 0 && (
                                    <span className="badge bg-primary rounded-pill small">
                                      {filterOwners.length}
                                    </span>
                                  )}
                                </div>
                                {openAccordion === "owner" && (
                                  <div className="filter-set-contents accordion-collapse">
                                    <div className="filter-content-list">
                                      <div className="mb-2 icon-form">
                                        <span className="form-icon">
                                          <i className="ti ti-search" />
                                        </span>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Search Lead Owner"
                                          value={filterOwnersSearch}
                                          onChange={(e) =>
                                            setFilterOwnersSearch(
                                              e.target.value
                                            )
                                          }
                                        />
                                      </div>
                                      {uniqueOwners
                                        .filter((n) =>
                                          n
                                            .toLowerCase()
                                            .includes(
                                              filterOwnersSearch.toLowerCase()
                                            )
                                        )
                                        .map((owner) => (
                                          <li key={owner}>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input
                                                  type="checkbox"
                                                  checked={filterOwners.includes(
                                                    owner
                                                  )}
                                                  onChange={() =>
                                                    handleFilterChange(
                                                      owner,
                                                      filterOwners,
                                                      setFilterOwners
                                                    )
                                                  }
                                                />
                                                <span className="checkmarks" />{" "}
                                                {owner}
                                              </label>
                                            </div>
                                          </li>
                                        ))}
                                      {uniqueOwners.filter((n) =>
                                        n
                                          .toLowerCase()
                                          .includes(
                                            filterOwnersSearch.toLowerCase()
                                          )
                                      ).length === 0 && (
                                          <p className="text-muted px-2">
                                            No data found
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                )}
                              </div>
                              <hr className="my-2" />
                              {/* Lead Type */}
                              <div className="filter-set-content">
                                <div className="filter-set-content-head d-flex align-items-center gap-2">
                                  <Link
                                    to="#"
                                    className={`filter-accordion-link ${
                                      openAccordion === "leadtype"
                                        ? ""
                                        : "collapsed"
                                    }`}
                                    onClick={() =>
                                      handleAccordionToggle("leadtype")
                                    }
                                  >
                                    Lead Type
                                    {/* <i
                                      className={`ti ${
                                        openAccordion === "leadtype"
                                          ? "ti-chevron-up"
                                          : "ti-chevron-down"
                                      } ms-2`}
                                    /> */}
                                  </Link>
                                  {filterLeadTypes.length > 0 && (
                                    <span className="badge bg-primary rounded-pill small">
                                      {filterLeadTypes.length}
                                    </span>
                                  )}
                                </div>
                                {openAccordion === "leadtype" && (
                                  <div className="filter-set-contents accordion-collapse">
                                    <div className="filter-content-list">
                                      <div className="mb-2 icon-form">
                                        <span className="form-icon">
                                          <i className="ti ti-search" />
                                        </span>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Search Lead Type"
                                          value={leadTypeSearch}
                                          onChange={(e) =>
                                            setLeadTypeSearch(e.target.value)
                                          }
                                        />
                                      </div>
                                      {uniqueLeadTypes
                                        .filter((n) =>
                                          n
                                            .toLowerCase()
                                            .includes(
                                              leadTypeSearch.toLowerCase()
                                            )
                                        )
                                        .map((ltype) => (
                                          <li key={ltype}>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input
                                                  type="checkbox"
                                                  checked={filterLeadTypes.includes(
                                                    ltype
                                                  )}
                                                  onChange={() =>
                                                    handleFilterChange(
                                                      ltype,
                                                      filterLeadTypes,
                                                      setFilterLeadTypes
                                                    )
                                                  }
                                                />
                                                <span className="checkmarks" />{" "}
                                                {ltype}
                                              </label>
                                            </div>
                                          </li>
                                        ))}
                                      {uniqueLeadTypes.filter((n) =>
                                        n
                                          .toLowerCase()
                                          .includes(
                                            leadTypeSearch.toLowerCase()
                                          )
                                      ).length === 0 && (
                                          <p className="text-muted px-2">
                                            No data found
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                )}
                              </div>
                              <hr className="my-2" />
                              {/* Lead Source */}
                              <div className="filter-set-content">
                                <div className="filter-set-content-head d-flex align-items-center gap-2">
                                  <Link
                                    to="#"
                                    className={`filter-accordion-link ${
                                      openAccordion === "leadsource"
                                        ? ""
                                        : "collapsed"
                                    }`}
                                    onClick={() =>
                                      handleAccordionToggle("leadsource")
                                    }
                                  >
                                    Lead Source
                                    {/* <i
                                      className={`ti ${
                                        openAccordion === "leadsource"
                                          ? "ti-chevron-up"
                                          : "ti-chevron-down"
                                      } ms-2`}
                                    /> */}
                                  </Link>
                                  {filterLeadSources.length > 0 && (
                                    <span className="badge bg-primary rounded-pill small">
                                      {filterLeadSources.length}
                                    </span>
                                  )}
                                </div>
                                {openAccordion === "leadsource" && (
                                  <div className="filter-set-contents accordion-collapse">
                                    <div className="filter-content-list">
                                      <div className="mb-2 icon-form">
                                        <span className="form-icon">
                                          <i className="ti ti-search" />
                                        </span>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Search Lead Source"
                                          value={leadSourceSearch}
                                          onChange={(e) =>
                                            setLeadSourceSearch(e.target.value)
                                          }
                                        />
                                      </div>
                                      {uniqueLeadSources
                                        .filter((n) =>
                                          n
                                            .toLowerCase()
                                            .includes(
                                              leadSourceSearch.toLowerCase()
                                            )
                                        )
                                        .map((source) => (
                                          <li key={source}>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input
                                                  type="checkbox"
                                                  checked={filterLeadSources.includes(
                                                    source
                                                  )}
                                                  onChange={() =>
                                                    handleFilterChange(
                                                      source,
                                                      filterLeadSources,
                                                      setFilterLeadSources
                                                    )
                                                  }
                                                />
                                                <span className="checkmarks" />{" "}
                                                {source}
                                              </label>
                                            </div>
                                          </li>
                                        ))}
                                      {uniqueLeadSources.filter((n) =>
                                        n
                                          .toLowerCase()
                                          .includes(
                                            leadSourceSearch.toLowerCase()
                                          )
                                      ).length === 0 && (
                                          <p className="text-muted px-2">
                                            No data found
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                )}
                              </div>
                              <hr className="my-2" />
                              {/* Lead Industry */}
                              <div className="filter-set-content">
                                <div className="filter-set-content-head d-flex align-items-center gap-2">
                                  <Link
                                    to="#"
                                    className={`filter-accordion-link ${
                                      openAccordion === "industry"
                                        ? ""
                                        : "collapsed"
                                    }`}
                                    onClick={() =>
                                      handleAccordionToggle("industry")
                                    }
                                  >
                                    Lead Industry
                                    {/* <i
                                      className={`ti ${
                                        openAccordion === "industry"
                                          ? "ti-chevron-up"
                                          : "ti-chevron-down"
                                      } ms-2`}
                                    /> */}
                                  </Link>
                                  {filterIndustries.length > 0 && (
                                    <span className="badge bg-primary rounded-pill small">
                                      {filterIndustries.length}
                                    </span>
                                  )}
                                </div>
                                {openAccordion === "industry" && (
                                  <div className="filter-set-contents accordion-collapse">
                                    <div className="filter-content-list">
                                      <div className="mb-2 icon-form">
                                        <span className="form-icon">
                                          <i className="ti ti-search" />
                                        </span>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Search Lead Industry"
                                          value={industrySearch}
                                          onChange={(e) =>
                                            setIndustrySearch(e.target.value)
                                          }
                                        />
                                      </div>
                                      {uniqueIndustries
                                        .filter((n) =>
                                          n
                                            .toLowerCase()
                                            .includes(
                                              industrySearch.toLowerCase()
                                            )
                                        )
                                        .map((industry) => (
                                          <li key={industry}>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input
                                                  type="checkbox"
                                                  checked={filterIndustries.includes(
                                                    industry
                                                  )}
                                                  onChange={() =>
                                                    handleFilterChange(
                                                      industry,
                                                      filterIndustries,
                                                      setFilterIndustries
                                                    )
                                                  }
                                                />
                                                <span className="checkmarks" />{" "}
                                                {industry}
                                              </label>
                                            </div>
                                          </li>
                                        ))}
                                      {uniqueIndustries.filter((n) =>
                                        n
                                          .toLowerCase()
                                          .includes(
                                            industrySearch.toLowerCase()
                                          )
                                      ).length === 0 && (
                                          <p className="text-muted px-2">
                                            No data found
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                )}
                              </div>
    <hr className="my-2" />
                                <div className="filter-set-content">
                                  <div className="filter-set-content-head">
                                    <Link
                                      to="#"
                                      className="collapsed"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#leadgivenby"
                                    >
                                      Lead Given By
                                    </Link>
                                  </div>
                                  <div
                                    className="filter-set-contents accordion-collapse collapse"
                                    id="leadgivenby"
                                  >
                                    <div className="filter-content-list">
                                      <div className="mb-2 icon-form">
                                        <span className="form-icon">
                                          <i className="ti ti-search" />
                                        </span>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Search Lead Given By"
                                          value={leadGivenBySearch}
                                          onChange={(e) =>
                                            setLeadGivenBySearch(e.target.value)
                                          }
                                        />
                                      </div>
                                      {Array.from(
                                        new Set(
                                          leadList.map(
                                            (l) =>
                                              l.leadgiven_by?.LeadGivenBy_name
                                          )
                                        )
                                      )
                                        .filter(
                                          (n): n is string =>
                                            typeof n === "string"
                                        )
                                        .filter((n) =>
                                          n
                                            .toLowerCase()
                                            .includes(
                                              leadGivenBySearch.toLowerCase()
                                            )
                                        )
                                        .map((name) => (
                                          <li key={name}>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input
                                                  type="checkbox"
                                                  checked={filterLeadGivenBy.includes(
                                                    name!
                                                  )}
                                                  onChange={() =>
                                                    handleFilterChange(
                                                      name!,
                                                      filterLeadGivenBy,
                                                      setFilterLeadGivenBy
                                                    )
                                                  }
                                                />
                                                <span className="checkmarks" />{" "}
                                                {name}
                                              </label>
                                            </div>
                                          </li>
                                        ))}
                                    </div>
                                  </div>
                                </div>                              <hr className="my-2" />
                              {/* Lead Stage */}
                              <div className="filter-set-content">
                                <div className="filter-set-content-head d-flex align-items-center gap-2">
                                  <Link
                                    to="#"
                                    className={`filter-accordion-link ${
                                      openAccordion === "stage"
                                        ? ""
                                        : "collapsed"
                                    }`}
                                    onClick={() =>
                                      handleAccordionToggle("stage")
                                    }
                                  >
                                    Lead Stage
                                    {/* <i
                                      className={`ti ${
                                        openAccordion === "stage"
                                          ? "ti-chevron-up"
                                          : "ti-chevron-down"
                                      } ms-2`}
                                    /> */}
                                  </Link>
                                  {filterStages.length > 0 && (
                                    <span className="badge bg-primary rounded-pill small">
                                      {filterStages.length}
                                    </span>
                                  )}
                                </div>
                                {openAccordion === "stage" && (
                                  <div className="filter-set-contents accordion-collapse">
                                    <div className="filter-content-list">
                                      <div className="mb-2 icon-form">
                                        <span className="form-icon">
                                          <i className="ti ti-search" />
                                        </span>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Search Stage"
                                          value={stageSearch}
                                          onChange={(e) =>
                                            setStageSearch(e.target.value)
                                          }
                                        />
                                      </div>
                                      {uniqueStages
                                        .filter((n) =>
                                          n
                                            .toLowerCase()
                                            .includes(stageSearch.toLowerCase())
                                        )
                                        .map((stage) => (
                                          <li key={stage}>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input
                                                  type="checkbox"
                                                  checked={filterStages.includes(
                                                    stage
                                                  )}
                                                  onChange={() =>
                                                    handleFilterChange(
                                                      stage,
                                                      filterStages,
                                                      setFilterStages
                                                    )
                                                  }
                                                />
                                                <span className="checkmarks" />{" "}
                                                {stage}
                                              </label>
                                            </div>
                                          </li>
                                        ))}
                                      {uniqueStages.filter((n) =>
                                        n
                                          .toLowerCase()
                                          .includes(stageSearch.toLowerCase())
                                      ).length === 0 && (
                                          <p className="text-muted px-2">
                                            No data found
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                )}
                              </div>
                              <hr className="my-2" />
                              {/* Course */}
                              <div className="filter-set-content">
                                <div className="filter-set-content-head d-flex align-items-center gap-2">
                                  <Link
                                    to="#"
                                    className={`filter-accordion-link ${
                                      openAccordion === "product"
                                        ? ""
                                        : "collapsed"
                                    }`}
                                    onClick={() =>
                                      handleAccordionToggle("product")
                                    }
                                  >
                                    Course
                                    {/* <i
                                      className={`ti ${
                                        openAccordion === "product"
                                          ? "ti-chevron-up"
                                          : "ti-chevron-down"
                                      } ms-2`}
                                    /> */}
                                  </Link>
                                  {filterProducts.length > 0 && (
                                    <span className="badge bg-primary rounded-pill small">
                                      {filterProducts.length}
                                    </span>
                                  )}
                                </div>
                                {openAccordion === "product" && (
                                  <div className="filter-set-contents accordion-collapse">
                                    <div className="filter-content-list">
                                      <div className="mb-2 icon-form">
                                        <span className="form-icon">
                                          <i className="ti ti-search" />
                                        </span>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Search Course"
                                          value={productSearch}
                                          onChange={(e) =>
                                            setProductSearch(e.target.value)
                                          }
                                        />
                                      </div>
                                      {uniqueProducts
                                        .filter((n) =>
                                          n
                                            .toLowerCase()
                                            .includes(
                                              productSearch.toLowerCase()
                                            )
                                        )
                                        .map((product) => (
                                          <li key={product}>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input
                                                  type="checkbox"
                                                  checked={filterProducts.includes(
                                                    product
                                                  )}
                                                  onChange={() =>
                                                    handleFilterChange(
                                                      product,
                                                      filterProducts,
                                                      setFilterProducts
                                                    )
                                                  }
                                                />
                                                <span className="checkmarks" />{" "}
                                                {product}
                                              </label>
                                            </div>
                                          </li>
                                        ))}
                                      {uniqueProducts.filter((n) =>
                                        n
                                          .toLowerCase()
                                          .includes(productSearch.toLowerCase())
                                      ).length === 0 && (
                                          <p className="text-muted px-2">
                                            No data found
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                )}
                              </div>

                              <hr className="my-2" />

                              {/* Course Type */}
                              <div className="filter-set-content">
                                <div className="filter-set-content-head d-flex align-items-center gap-2">
                                  <Link
                                    to="#"
                                    className={`filter-accordion-link ${
                                      openAccordion === "producttype"
                                        ? ""
                                        : "collapsed"
                                    }`}
                                    onClick={() =>
                                      handleAccordionToggle("producttype")
                                    }
                                  >
                                    Course Type
                                    {/* <i
                                      className={`ti ${
                                        openAccordion === "producttype"
                                          ? "ti-chevron-up"
                                          : "ti-chevron-down"
                                      } ms-2`}
                                    /> */}
                                  </Link>
                                  {filterProductTypes.length > 0 && (
                                    <span className="badge bg-primary rounded-pill small">
                                      {filterProductTypes.length}
                                    </span>
                                  )}
                                </div>
                                {openAccordion === "producttype" && (
                                  <div className="filter-set-contents accordion-collapse">
                                    <div className="filter-content-list">
                                      <div className="mb-2 icon-form">
                                        <span className="form-icon">
                                          <i className="ti ti-search" />
                                        </span>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Search Course Type"
                                          value={productTypeSearch}
                                          onChange={(e) =>
                                            setProductTypeSearch(e.target.value)
                                          }
                                        />
                                      </div>
                                      {uniqueProductTypes
                                        .filter((n) =>
                                          n
                                            .toLowerCase()
                                            .includes(
                                              productTypeSearch.toLowerCase()
                                            )
                                        )
                                        .map((ptype) => (
                                          <li key={ptype}>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input
                                                  type="checkbox"
                                                  checked={filterProductTypes.includes(
                                                    ptype
                                                  )}
                                                  onChange={() =>
                                                    handleFilterChange(
                                                      ptype,
                                                      filterProductTypes,
                                                      setFilterProductTypes
                                                    )
                                                  }
                                                />
                                                <span className="checkmarks" />{" "}
                                                {ptype}
                                              </label>
                                            </div>
                                          </li>
                                        ))}
                                      {uniqueProductTypes.filter((n) =>
                                        n
                                          .toLowerCase()
                                          .includes(
                                            productTypeSearch.toLowerCase()
                                          )
                                      ).length === 0 && (
                                          <p className="text-muted px-2">
                                            No data found
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                )}
                              </div>

                              <hr className="my-2" />

                              {/* Customer Potential */}
                              <div className="filter-set-content">
                                <div className="filter-set-content-head d-flex align-items-center gap-2">
                                  <Link
                                    to="#"
                                    className={`filter-accordion-link ${
                                      openAccordion === "customerpotential"
                                        ? ""
                                        : "collapsed"
                                    }`}
                                    onClick={() =>
                                      handleAccordionToggle("customerpotential")
                                    }
                                  >
                                    Customer Potential
                                    {/* <i
                                      className={`ti ${
                                        openAccordion === "customerpotential"
                                          ? "ti-chevron-up"
                                          : "ti-chevron-down"
                                      } ms-2`}
                                    /> */}
                                  </Link>
                                  {filterCustomerPotentials.length > 0 && (
                                    <span className="badge bg-primary rounded-pill small">
                                      {filterCustomerPotentials.length}
                                    </span>
                                  )}
                                </div>
                                {openAccordion === "customerpotential" && (
                                  <div className="filter-set-contents accordion-collapse">
                                    <div className="filter-content-list">
                                      <div className="mb-2 icon-form">
                                        <span className="form-icon">
                                          <i className="ti ti-search" />
                                        </span>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Search Customer Potential"
                                          value={customerPotentialSearch}
                                          onChange={(e) =>
                                            setCustomerPotentialSearch(
                                              e.target.value
                                            )
                                          }
                                        />
                                      </div>
                                      {uniqueCustomerPotentials
                                        .filter((n) =>
                                          n
                                            .toLowerCase()
                                            .includes(
                                              customerPotentialSearch.toLowerCase()
                                            )
                                        )
                                        .map((cp) => (
                                          <li key={cp}>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input
                                                  type="checkbox"
                                                  checked={filterCustomerPotentials.includes(
                                                    cp
                                                  )}
                                                  onChange={() =>
                                                    handleFilterChange(
                                                      cp,
                                                      filterCustomerPotentials,
                                                      setFilterCustomerPotentials
                                                    )
                                                  }
                                                />
                                                <span className="checkmarks" />{" "}
                                                {cp}
                                              </label>
                                            </div>
                                          </li>
                                        ))}
                                      {uniqueCustomerPotentials.filter((n) =>
                                        n
                                          .toLowerCase()
                                          .includes(
                                            customerPotentialSearch.toLowerCase()
                                          )
                                      ).length === 0 && (
                                          <p className="text-muted px-2">
                                            No data found
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>

 <hr className="my-2" />
                              <div className="filter-set-content">
                                <div className="filter-set-content-head">
                                  <Link
                                    to="#"
                                    className="collapsed"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#contributors"
                                  >
                                    Contributors
                                  </Link>
                                </div>
                                <div
                                  className="filter-set-contents accordion-collapse collapse"
                                  id="contributors"
                                >
                                  <div className="filter-content-list">
                                    {/* Search Box */}
                                    <div className="mb-2 icon-form">
                                      <span className="form-icon">
                                        <i className="ti ti-search" />
                                      </span>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search Contributors"
                                        value={contributorSearch}
                                        onChange={(e) =>
                                          setContributorSearch(e.target.value)
                                        }
                                      />
                                    </div>

                                    {/* Contributor Options */}
                                    {Array.from(
                                      new Set(
                                        leadList.flatMap((l) => [
                                          ...(l.leadcontributor_names || []),
                                          ...(l.contributor?.name
                                            ? [l.contributor.name]
                                            : []),
                                        ])
                                      )
                                    )
                                      .filter(
                                        (n): n is string =>
                                          typeof n === "string"
                                      )
                                      .filter((n) =>
                                        n
                                          .toLowerCase()
                                          .includes(
                                            contributorSearch.toLowerCase()
                                          )
                                      )
                                      .map((contrib) => (
                                        <li key={contrib}>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input
                                                type="checkbox"
                                                checked={filterContributors.includes(
                                                  contrib
                                                )}
                                                onChange={() => {
                                                  setFilterContributors(
                                                    (prev) =>
                                                      prev.includes(contrib)
                                                        ? prev.filter(
                                                            (c) => c !== contrib
                                                          )
                                                        : [...prev, contrib]
                                                  );
                                                }}
                                              />
                                              <span className="checkmarks" />{" "}
                                              {contrib}
                                            </label>
                                          </div>
                                        </li>
                                      ))}

                                    {/* Empty State */}
                                    {Array.from(
                                      new Set(
                                        leadList.flatMap((l) => [
                                          ...(l.leadcontributor_names || []),
                                          ...(l.contributor?.name
                                            ? [l.contributor.name]
                                            : []),
                                        ])
                                      )
                                    )
                                      .filter(
                                        (n): n is string =>
                                          typeof n === "string"
                                      )
                                      .filter((n) =>
                                        n
                                          .toLowerCase()
                                          .includes(
                                            contributorSearch.toLowerCase()
                                          )
                                      ).length === 0 && (
                                      <p className="text-muted px-2">
                                        No contributors found
                                      </p>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <hr className="my-2" />
                              <div className="filter-set-content">
                                <div className="filter-set-content-head">
                                  <Link
                                    to="#"
                                    className="collapsed"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#migratingfrom"
                                  >
                                    Migrating From
                                  </Link>
                                </div>
                                <div
                                  className="filter-set-contents accordion-collapse collapse"
                                  id="migratingfrom"
                                >
                                  <div className="filter-content-list">
                                    <div className="mb-2 icon-form">
                                      <span className="form-icon">
                                        <i className="ti ti-search" />
                                      </span>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search Migrating From"
                                        value={migratingFromSearch}
                                        onChange={(e) =>
                                          setMigratingFromSearch(e.target.value)
                                        }
                                      />
                                    </div>
                                    {Array.from(
                                      new Set(
                                        leadList
                                          .map((l) => l.migrating_from)
                                          .filter(Boolean)
                                      )
                                    )
                                      .filter(
                                        (n): n is string =>
                                          typeof n === "string"
                                      )
                                      .filter((n) =>
                                        n
                                          .toLowerCase()
                                          .includes(
                                            migratingFromSearch.toLowerCase()
                                          )
                                      )
                                      .map((mf) => (
                                        <li key={mf}>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input
                                                type="checkbox"
                                                checked={filterMigratingFrom.includes(
                                                  mf
                                                )}
                                                onChange={() =>
                                                  handleFilterChange(
                                                    mf,
                                                    filterMigratingFrom,
                                                    setFilterMigratingFrom
                                                  )
                                                }
                                              />
                                              <span className="checkmarks" />{" "}
                                              {mf}
                                            </label>
                                          </div>
                                        </li>
                                      ))}
                                    {Array.from(
                                      new Set(
                                        leadList
                                          .map((l) => l.migrating_from)
                                          .filter(Boolean)
                                      )
                                    )
                                      .filter(
                                        (n): n is string =>
                                          typeof n === "string"
                                      )
                                      .filter((n) =>
                                        n
                                          .toLowerCase()
                                          .includes(
                                            migratingFromSearch.toLowerCase()
                                          )
                                      ).length === 0 && (
                                      <p className="text-muted px-2">
                                        No data found
                                      </p>
                                    )}
                                  </div>
                                </div>
                              </div>
                               <hr className="my-2" />
                                <div className="filter-set-content">
                                  <div className="filter-set-content-head">
                                    <Link
                                      to="#"
                                      className="collapsed"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#createdDate"
                                    >
                                      Created Date
                                    </Link>
                                  </div>
                                  <div
                                    className="filter-set-contents accordion-collapse collapse"
                                    id="createdDate"
                                  >
                                    <div className="filter-content-list">
                                      <div className="mb-2 icon-form">
                                        <span className="form-icon">
                                          <i className="ti ti-search" />
                                        </span>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Search Date"
                                          value={filterDatesSearch}
                                          onChange={(e) =>
                                            setFilterDatesSearch(e.target.value)
                                          }
                                        />
                                      </div>
                                      <ul>
  {Array.from(
    new Set(
      leadList.map((lead) => lead.created_at?.split("T")[0]) // store raw YYYY-MM-DD
    )
  )
    .filter(Boolean)
    .filter((date) =>
      date.toLowerCase().includes(filterDatesSearch.toLowerCase())
    )
    .map((date) => (
      <li key={date}>
        <div className="filter-checks">
          <label className="checkboxs">
            <input
              type="checkbox"
              checked={filterDates.includes(date)} // compare raw date
              onChange={() =>
                handleFilterChange(date, filterDates, setFilterDates)
              }
            />
            <span className="checkmarks" />
            {new Date(date).toLocaleDateString()} {/* Display pretty */}
          </label>
        </div>
      </li>
    ))}
</ul>

                                    </div>
                                  </div>
                                </div>                            <div className="filter-reset-btns">
                              <div className="row">
                                <div className="col-6">
                                  <Link
                                    to="#"
                                    className="btn btn-light w-100"
                                    onClick={() => {
                                      // Reset all filters
                                      setFilterNames([]);
                                      setFilterCompanies([]);
                                      setFilterStatuses([]);
                                      setFilterOwners([]);
                                      setFilterLeadTypes([]);
                                      setFilterLeadSources([]);
                                      setFilterIndustries([]);
                                      setFilterStages([]);
                                      setFilterProducts([]);
                                      setFilterProductTypes([]);
                                      setFilterCustomerPotentials([]);
                                      setFilterNamesSearch("");
                                      setFilterCompaniesSearch("");
                                      setFilterStatusesSearch("");
                                      setFilterOwnersSearch("");
                                      setLeadTypeSearch("");
                                      setLeadSourceSearch("");
                                      setIndustrySearch("");
                                      setStageSearch("");
                                      setProductSearch("");
                                      setProductTypeSearch("");
                                      setCustomerPotentialSearch("");
                                      // Close all accordion sections
                                      setOpenAccordion(null);
                                       setFilterMigratingFrom([]);
                                        setFilterDatesSearch("");
                                        setMigratingFromSearch("");
                                    }}
                                  >
                                    Reset
                                  </Link>
                                </div>
                                <div className="col-6">
                                  <Link
                                    to="#"
                                    className="btn btn-primary"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      // Optionally close the dropdown or trigger a toast
                                      // toast.info("Filters applied");
                                    }}
                                  >
                                    Filter
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="view-icons">
                        <Link to={route.leads} className="active">
                          <i className="ti ti-list-tree" />
                        </Link>
                        <Link to={route.leadsKanban}>
                          <i className="ti ti-grid-dots" />
                        </Link>
                      </div>
                    </div>
                  </div>
                  {/* Active filter highlights */}
                  {(filterNames.length > 0 ||
                    filterCompanies.length > 0 ||
                    filterStatuses.length > 0 ||
                    filterOwners.length > 0 ||
                    filterLeadTypes.length > 0 ||
                    filterLeadSources.length > 0 ||
                    filterIndustries.length > 0 ||
                    filterStages.length > 0 ||
                    filterProducts.length > 0 ||
                    filterProductTypes.length > 0 ||
                    filterCustomerPotentials.length > 0 ||
                    searchQuery.length > 0 ||
  filterContributors.length > 0 ||
                      sortOption !== "recently_added" ||
                    activeLeadStatusTab !== "all_leads" ||
                    leadStatusFilter !== "all" ||
                    selectedDateRange ||
                    createdAtFilter) && (
                      <div className="active-filters d-flex flex-wrap gap-2 mb-4 align-items-center-3">
                        {filterNames.length > 0 && (
                          <div className="alert alert-primary py-2 mb-2">
                            Showing leads with names:{" "}
                            <strong>{filterNames.join(", ")}</strong>
                            <i
                              className="ti ti-x fs-12 cursor-pointer ms-2"
                              onClick={() => setFilterNames([])}
                            />
                          </div>
                        )}
                        {filterCompanies.length > 0 && (
                          <div className="alert alert-secondary py-2 mb-2">
                            Showing leads with companies:{" "}
                            <strong>{filterCompanies.join(", ")}</strong>
                            <i
                              className="ti ti-x fs-12 cursor-pointer ms-2"
                              onClick={() => setFilterCompanies([])}
                            />
                          </div>
                        )}
                        {filterStatuses.length > 0 && (
                          <div className="alert alert-warning py-2 mb-2">
                            Showing leads with status:{" "}
                            <strong>{filterStatuses.join(", ")}</strong>
                            <i
                              className="ti ti-x fs-12 cursor-pointer ms-2"
                              onClick={() => setFilterStatuses([])}
                            />
                          </div>
                        )}
                        {filterOwners.length > 0 && (
                          <div className="alert alert-info py-2 mb-2">
                            Showing leads with owners:{" "}
                            <strong>{filterOwners.join(", ")}</strong>
                            <i
                              className="ti ti-x fs-12 cursor-pointer ms-2"
                              onClick={() => setFilterOwners([])}
                            />
                          </div>
                        )}
                        {filterLeadTypes.length > 0 && (
                          <div className="alert alert-success py-2 mb-2">
                            Showing leads of type:{" "}
                            <strong>{filterLeadTypes.join(", ")}</strong>
                            <i
                              className="ti ti-x fs-12 cursor-pointer ms-2"
                              onClick={() => setFilterLeadTypes([])}
                            />
                          </div>
                        )}
                        {filterLeadSources.length > 0 && (
                          <div className="alert alert-primary py-2 mb-2">
                            Showing leads from source:{" "}
                            <strong>{filterLeadSources.join(", ")}</strong>
                            <i
                              className="ti ti-x fs-12 cursor-pointer ms-2"
                              onClick={() => setFilterLeadSources([])}
                            />
                          </div>
                        )}
                        {filterIndustries.length > 0 && (
                          <div className="alert alert-danger py-2 mb-2">
                            Showing leads in industries:{" "}
                            <strong>{filterIndustries.join(", ")}</strong>
                            <i
                              className="ti ti-x fs-12 cursor-pointer ms-2"
                              onClick={() => setFilterIndustries([])}
                            />
                          </div>
                        )}
                        {filterStages.length > 0 && (
                          <div className="alert alert-secondary py-2 mb-2">
                            Showing leads at stage:{" "}
                            <strong>{filterStages.join(", ")}</strong>
                            <i
                              className="ti ti-x fs-12 cursor-pointer ms-2"
                              onClick={() => setFilterStages([])}
                            />
                          </div>
                        )}
                        {filterProducts.length > 0 && (
                          <div className="alert alert-warning py-2 mb-2">
                            Showing leads with products:{" "}
                            <strong>{filterProducts.join(", ")}</strong>
                            <i
                              className="ti ti-x fs-12 cursor-pointer ms-2"
                              onClick={() => setFilterProducts([])}
                            />
                          </div>
                        )}
                        {filterProductTypes.length > 0 && (
                          <div className="alert alert-info py-2 mb-2">
                            Showing leads with product types:{" "}
                            <strong>{filterProductTypes.join(", ")}</strong>
                            <i
                              className="ti ti-x fs-12 cursor-pointer ms-2"
                              onClick={() => setFilterProductTypes([])}
                            />
                          </div>
                        )}
                        {filterCustomerPotentials.length > 0 && (
                          <div className="alert alert-success py-2 mb-2">
                            Showing leads with customer potentials:{" "}
                            <strong>{filterCustomerPotentials.join(", ")}</strong>
                            <i
                              className="ti ti-x fs-12 cursor-pointer ms-2"
                              onClick={() => setFilterCustomerPotentials([])}
                            />
                      {filterLeadGivenBy.length > 0 && (
                        <div className="alert alert-success py-2 mb-2">
                          Showing leads with lead givenby:{" "}
                          <strong>{filterLeadGivenBy.join(", ")}</strong>
                          <i className="ti ti-x fs-12 cursor-pointer ms-2" onClick={() => setFilterLeadGivenBy([])} />
                        </div>
                      )}
                        {filterMigratingFrom.length > 0 && (
                          <div className="alert alert-info py-2 mb-2">
                            Showing leads migrating from:{" "}
                            <strong>{filterMigratingFrom.join(", ")}</strong>
                            <i className="ti ti-x fs-12 cursor-pointer ms-2" onClick={() => setFilterMigratingFrom([])} />
                          </div>
                        )}
                        {filterContributors.length > 0 && (
                          <div className="alert alert-info py-2 mb-2">
                            Showing contributor:{" "}
                            <strong>{filterContributors.join(", ")}</strong>
                            <i className="ti ti-x fs-12 cursor-pointer ms-2" onClick={() => setFilterContributors([])} />
                          </div>
                        )}                          </div>
                        )}
                        {searchQuery.length > 0 && (
                          <div className="alert alert-primary py-2 mb-2">
                            Showing leads for search :{" "}
                            <strong>{searchQuery}</strong>
                            <i
                              className="ti ti-x fs-12 cursor-pointer ms-2"
                              onClick={() => setSearchQuery("")}
                            />
                          </div>
                        )}
                        {sortOption !== "recently_added" && (
                          <div className="alert alert-secondary py-2 mb-2">
                            Showing leads sorted by:{" "}
                            <strong>
                              {sortOption
                                .replace(/_/g, " ")
                                .charAt(0)
                                .toUpperCase() +
                                sortOption.replace(/_/g, " ").slice(1)}
                            </strong>
                            <i
                              className="ti ti-x fs-12 cursor-pointer ms-2"
                              onClick={() => setSortOption("recently_added")}
                            />
                          </div>
                        )}
                        {activeLeadStatusTab &&
                          activeLeadStatusTab !== "all_leads" && (
                            <div
                              className={`alert py-2 mb-2 ${{
                                Not_Contacted: "alert-warning",
                                Contacted: "alert-info",
                                Closed: "alert-success",
                                Lost: "alert-danger",
                              }[activeLeadStatusTab] || "alert-secondary"
                                }`}
                            >
                              Showing leads with status:{" "}
                              <strong>
                                {(activeLeadStatusTab || "")
                                  .replace(/_/g, " ")
                                  .charAt(0)
                                  .toUpperCase() +
                                  (activeLeadStatusTab || "")
                                    .replace(/_/g, " ")
                                    .slice(1)}
                              </strong>
                              <i
                                className="ti ti-x fs-12 cursor-pointer ms-2"
                                onClick={() => {
                                  setActiveLeadStatusTab(null);
                                  setFilterStatuses([]);
                                }}
                              />
                            </div>
                          )}
                        {leadStatusFilter !== "all" && (
                          <div
                            className={`alert py-2 mb-2 ${{
                              Not_Contacted: "alert-warning",
                              Contacted: "alert-info",
                              Closed: "alert-success",
                              Lost: "alert-danger",
                            }[leadStatusFilter] || "alert-secondary"
                              }`}
                            style={{ borderRadius: 6, fontSize: 13 }}
                          >
                            Status:{" "}
                            <strong className="ms-1">
                              {leadStatusFilter.replace(/_/g, " ")}
                            </strong>
                            <i
                              className="ti ti-x fs-12 cursor-pointer ms-2"
                              onClick={() => setLeadStatusFilter("all")}
                            />
                          </div>
                        )}
                        {selectedDateRange && (
                          <div className="alert alert-warning py-2 mb-2">
                            Showing leads created between:{" "}
                            <strong>
                              {selectedDateRange[0].toLocaleDateString()} -{" "}
                              {selectedDateRange[1].toLocaleDateString()}
                            </strong>
                            <i
                              className="ti ti-x fs-12 cursor-pointer ms-2"
                              onClick={() => setSelectedDateRange(null)}
                            />
                          </div>
                        )}
 {filterDates.length > 0 && (
  <div className="alert alert-secondary py-2 mb-2">
    Created Dates:{" "}
    <strong>
      {filterDates
        .map((d) => new Date(d).toLocaleDateString())
        .join(", ")}
    </strong>

    <i
      className="ti ti-x fs-12 cursor-pointer ms-2"
      onClick={() => setFilterDates([])}
    />
  </div>
)}                      </div>
                    )}

                  {/* Contact List */}
                  <div className="table-responsive custom-table">
                  <Table
  dataSource={paginatedLeads}
  columns={columns}
  className="custom-table"
  rowKey="lead_id"
  loading={reduxReLeadsLoading}
  emptyText="No Leads found"
  emptyIcon="ti ti-target-off"
  enableRowSelection={true}
  rowSelection={{
    selectedRowKeys: selectedLeads,
    onChange: (selectedRowKeys) =>
      setSelectedLeads(selectedRowKeys.map(String)),
  }}
  rowClassName={(record: any) => {
    if (!showRowStatus) return "";
    const status = record.lead_status
      ?.toLowerCase()
      .replace(/\s|_/g, "-");
    return status ? `row-status-${status}` : "";
  }}
  recordLabel="Leads"
  draggable={true}
  enableColumnDrag={true}
  onRowOrderChange={handleRowOrderChange}
  onColumnOrderChange={(newCols: any[]) => {
    const newKeys = newCols
      .filter((c) => !c.fixed)
      .map((c) => c.key);
    setColumnKeys(newKeys);
  }}
  pagination={{
    current: currentPage,
    pageSize: pageSize,
    total: filteredAndSortedLeads.length,
    showSizeChanger: true,
    pageSizeOptions: ["10", "20", "50", "75", "100"],
    onChange: (page: number, size: number) => {
      setCurrentPage(page);
      setPageSize(size);
    },
  }}
  scroll={{ x: "max-content" }}   // ✅ COMMA HERE
  components={{
    
    body: {
      row: (props: any) => {
        const record = props["data-row-key"];
        const status = record?.lead_status;
        const statusClass =
          showRowStatus && status
            ? `row-status-${status
                .toLowerCase()
                .replace(/\s|_/g, "-")}`
            : "";

        return (
          <tr
            {...props}
            className={`${props.className || ""} ${statusClass}`}
            title={
              showRowStatus && status
                ? `Status: ${status.replace(/_/g, " ")}`
                : undefined
            }
          />
        );
      },
    },
  }}
/>

                  </div>
                  <div className="row align-items-center">
                    <div className="col-md-6">
                      <div className="datatable-length" />
                    </div>
                    <div className="col-md-6">
                      <div className="datatable-paginate" />
                    </div>
                  </div>
                  {/* /Contact List */}
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
        {/* /Page Wrapper */}
        {/* Add Lead */}
        <Offcanvas show={show2} onHide={handleClose2} placement="end">
          <div className="offcanvas-header border-bottom">
            <h4 className="fw-semibold">Add New Lead</h4>
            <button
              type="button"
              className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
              onClick={handleClose2}
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>

          <div className="offcanvas-body">
            <form>
              <h6 className="mt-3 mb-3 border-bottom pb-1">
                <i className="ti ti-building me-2 text-primary" />
                Company Info
              </h6>
              <div className="row">
                {/* Company */}
                <div className="col-md-12 col-sm-12 mb-3">
                  <label className="form-label" htmlFor="lead-company-name">
                    Company Name <span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ti ti-building" />{" "}
                      {/* Company/Organization icon */}
                    </span>
                    <div className="flex-grow-1">
                      <Select
                        inputId="lead-company-name"
                        classNamePrefix="react-select"
                        options={companyOptions}
                        onChange={handleCompanyChange}
                      />
                    </div>
                  </div>
                </div>

                {/* Lead Name */}
                <div className="col-md-6 col-sm-12 mb-3">
                  <label className="form-label" htmlFor="lead-name">
                    Lead Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="lead-name"
                    className="form-control"
                    value={selectedCompany?.company.contact_person_name || ""}
                    disabled
                  />
                </div>

                {/* Branch Dropdown */}
                <div className="col-md-6 col-sm-12 mb-3">
                  <label className="form-label" htmlFor="lead-branch">
                    Select Branch <span className="text-danger">*</span>
                  </label>
                  <Select
                    inputId="lead-branch"
                    options={selectedCompany?.branches?.map(
                      (branch: Branch) => ({
                        label: `${branch.branch_name} - ${branch.branch_city}, ${branch.branch_state}`,
                        value: branch.branch_id,
                      })
                    )}
                    value={
                      selectedBranch
                        ? {
                            label: `${selectedBranch.branch_name} - ${selectedBranch.branch_city}, ${selectedBranch.branch_state}`,
                            value: selectedBranch.branch_id,
                          }
                        : null
                    }
                    onChange={(selectedOption) => {
                      const branch = selectedCompany?.branches.find(
                        (b: Branch) => b.branch_id === selectedOption?.value
                      );
                      setSelectedBranch(branch);
                      setFormData((prev) => ({
                        ...prev,
                        branch_id: branch?.branch_id || "",
                      }));
                    }}
                    isDisabled={!selectedCompany}
                  />
                </div>

                {/* Phone */}
                <div className="col-md-6 col-sm-12 mb-3">
                  <label className="form-label" htmlFor="lead-phone">
                    Phone <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="lead-phone"
                    className="form-control"
                    value={selectedCompany?.company.company_phone || ""}
                    disabled
                  />
                </div>

                <div className="col-md-6 col-sm-12 mb-3">
                  <div className="mb-3">
                    <label className="form-label" htmlFor="lead-email">
                      Company Mail
                    </label>
                    <input
                      type="email"
                      id="lead-email"
                      className="form-control"
                      value={formData.contact_mail || ""}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          contact_mail: e.target.value,
                        }))
                      }
                      placeholder="Company email"
                    />
                  </div>
                </div>

                {/* Website */}
                <div className="col-md-6 col-sm-12 mb-3">
                  <label className="form-label" htmlFor="lead-website">
                    Website URL
                  </label>
                  <input
                    type="text"
                    id="lead-website"
                    className="form-control"
                    value={formData.website_url}
                    placeholder="Enter website URL (optional)"
                    onChange={(e) =>
                      setFormData({ ...formData, website_url: e.target.value })
                    }
                  />
                </div>
              </div>

              <h6 className="mt-4 mb-3 border-bottom pb-1">
                <i className="ti ti-users me-2 text-primary" />
                Lead Details
              </h6>
              <div className="row">
                {/* Lead Source */}
                <div className="col-md-6 col-sm-12 mb-3">
                  <label className="form-label" htmlFor="lead-source">
                    Lead Source <span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ti ti-database" /> {/* Lead Source icon */}
                    </span>
                    <div className="flex-grow-1">
                      <Select
                        inputId="lead-source"
                        //classNamePrefix="react-select"
                        options={leadSourceOptions}
                        value={leadSourceOptions.find(
                          (opt) => opt.value === formData.leadsource_id
                        )}
                        onChange={(opt) =>
                          handleInputChange("leadsource_id", opt?.value || "")
                        }
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-6 col-sm-12 mb-3">
                  <label className="form-label" htmlFor="lead-givenby">
                    Lead Given By<span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ti ti-user" /> {/* Lead Given By icon */}
                    </span>
                    <div className="flex-grow-1">
                      <Select
                        inputId="lead-givenby"
                        options={leadGivenByOptions}
                        value={leadGivenByOptions.find(
                          (opt) => opt.value === formData.leadgivenby_id
                        )}
                        onChange={(opt) =>
                          handleInputChange("leadgivenby_id", opt?.value || "")
                        }
                        placeholder="Select Lead Given By"
                      />
                    </div>
                  </div>
                </div>

                {/* Industry */}
                <div className="col-md-6 col-sm-12 mb-3">
                  <label className="form-label" htmlFor="lead-industry">
                    Lead Business Type
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ti ti-file-invoice" />{" "}
                      {/* Business / Industry icon */}
                    </span>
                    <div className="flex-grow-1">
                      <Select
                        inputId="lead-industry"
                        //classNamePrefix="react-select"
                        options={industryOptions}
                        value={industryOptions.find(
                          (opt) => opt.value === formData.leadindustry_id
                        )}
                        onChange={(opt) =>
                          handleInputChange("leadindustry_id", opt?.value || "")
                        }
                      />
                    </div>
                  </div>
                </div>

                {/* Lead Type */}
                <div className="col-md-6 col-sm-12 mb-3">
                  <label className="form-label" htmlFor="lead-type">
                    Lead Type <span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ti ti-category" />{" "}
                      {/* Category/Type icon */}
                    </span>
                    <div className="flex-grow-1">
                      <Select
                        inputId="lead-type"
                        //classNamePrefix="react-select"
                        options={leadTypeOptions}
                        value={leadTypeOptions.find(
                          (opt) => opt.value === formData.leadtype_id
                        )}
                        onChange={(opt) =>
                          handleInputChange("leadtype_id", opt?.value || "")
                        }
                      />
                    </div>
                  </div>
                </div>

                {/* Lead Stage */}
                <div className="col-md-6 col-sm-12 mb-3">
                  <label className="form-label" htmlFor="lead-stage">
                    Lead Stage <span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="bi bi-boxes" /> {/* Stage/Flag icon */}
                    </span>
                    <div className="flex-grow-1">
                      <Select
                        inputId="lead-stage"
                        //classNamePrefix="react-select"
                        options={leadStageOptions}
                        value={leadStageOptions.find(
                          (opt) => opt.value === formData.leadstage_id
                        )}
                        onChange={(opt) =>
                          handleInputChange("leadstage_id", opt?.value || "")
                        }
                      />
                    </div>
                  </div>
                </div>

                {/* Product */}
                <div className="col-md-6 col-sm-12 mb-3">
                  <label className="form-label" htmlFor="lead-product">
                    Product <span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="bi bi-box-seam" />{" "}
                      {/* Package/Product icon */}
                    </span>
                    <div className="flex-grow-1">
                      <Select
                        inputId="lead-product"
                        isMulti
                        //classNamePrefix="react-select"
                        options={productOptions}
                        value={productOptions.filter((opt) =>
                          formData.product_id?.split(",").includes(opt.value)
                        )}
                        onChange={(selectedOptions) => {
                          if (
                            selectedOptions &&
                            Array.isArray(selectedOptions)
                          ) {
                            const selectedIds = selectedOptions
                              .map((opt) => opt.value)
                              .join(",");
                            setSelectedProduct(selectedOptions);
                            setFormData((prev) => ({
                              ...prev,
                              product_id: selectedIds,
                            }));
                          } else {
                            setSelectedProduct([]);
                            setFormData((prev) => ({
                              ...prev,
                              product_id: "",
                            }));
                          }
                        }}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            minHeight: "auto",
                            height: "auto",
                            flexWrap: "wrap",
                            boxShadow: state.isFocused
                              ? "0 0 0 1px #ccc"
                              : base.boxShadow,
                            borderColor: state.isFocused
                              ? "#ccc"
                              : base.borderColor,
                          }),
                          valueContainer: (base) => ({
                            ...base,
                            flexWrap: "wrap",
                            paddingTop: "6px",
                            paddingBottom: "6px",
                          }),
                          multiValue: (base) => ({
                            ...base,
                            backgroundColor: "#f0f0f0",
                            borderRadius: "8px",
                            padding: "2px 6px",
                            fontSize: "0.85rem",
                          }),
                          multiValueLabel: (base) => ({
                            ...base,
                            color: "#333",
                            fontWeight: 500,
                          }),
                          multiValueRemove: (base) => ({
                            ...base,
                            color: "#888",
                            ":hover": {
                              backgroundColor: "#ccc",
                              color: "#000",
                            },
                          }),
                        }}
                      />
                    </div>
                  </div>
                </div>
                {/* {selectedProduct && (
                  <>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">No. of Logins</label>
                      <input
                        type="number"
                        min={1}
                        className="form-control"
                        value={
                          formData.no_logins === undefined
                            ? ""
                            : formData.no_logins
                        }
                        onChange={(e) => {
                          const value = e.target.value;

                          // Allow empty input
                          if (value === "") {
                            setFormData((prev) => ({
                              ...prev,
                              no_logins: undefined,
                              rate_per_login: 0,
                            }));
                            return;
                          }

                          const logins = parseInt(value, 10);
                          const productPrice =
                            selectedProduct?.data?.product_price || 0;

                          setFormData((prev) => ({
                            ...prev,
                            no_logins: logins,
                            rate_per_login: productPrice * logins,
                          }));
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                            // e.preventDefault(); // ⛔ block arrow keys
                          }
                        }}
                        onWheel={(e) => {
                          e.target instanceof HTMLElement && e.target.blur(); // ⛔ block scroll
                        }}
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label className="form-label">Rate per Login</label>
                      <input
                        type="text"
                        className="form-control"
                        value={
                          formData.rate_per_login !== null &&
                          formData.rate_per_login !== undefined
                            ? `₹${formData.rate_per_login}`
                            : "N/A"
                        }
                        readOnly
                      />
                    </div>
                  </>
                )} */}
                {/* Product Type */}
                <div className="col-md-6 col-sm-12 mb-3">
                  <label className="form-label" htmlFor="lead-product-type">
                    Product Type <span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ti ti-box" /> {/* Box/Product Type icon */}
                    </span>
                    <div className="flex-grow-1">
                      <Select
                        inputId="lead-product-type"
                        //classNamePrefix="react-select"
                        options={productTypeOptions}
                        value={productTypeOptions.find(
                          (opt) => opt.value === formData.product_type_id
                        )}
                        onChange={(selected) =>
                          setFormData((prev) => ({
                            ...prev,
                            product_type_id: selected?.value || "",
                          }))
                        }
                      />
                    </div>
                  </div>
                </div>

                {/* Customer Type */}
                <div className="col-md-6 col-sm-12 mb-3">
                  <label
                    className="form-label"
                    htmlFor="lead-customer-potential"
                  >
                    Customer Potential <span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ti ti-trending-up" />{" "}
                      {/* Growth/Potential icon */}
                    </span>
                    <div className="flex-grow-1">
                      <Select
                        inputId="lead-customer-potential"
                        //classNamePrefix="react-select"
                        options={customerTypeOptions}
                        value={customerTypeOptions.find(
                          (opt) => opt.value === formData.customerPotential_id
                        )}
                        onChange={(selected) =>
                          setFormData((prev) => ({
                            ...prev,
                            customerPotential_id: selected?.value || "",
                          }))
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              <h6 className="mt-4 mb-3 border-bottom pb-1">
                <i className="ti ti-file-description me-2 text-primary" />
                Additional Info
              </h6>
              <div className="row">
                {/* Migrating From */}
                <div className="col-md-6 col-sm-12 mb-3">
                  <label className="form-label" htmlFor="lead-migrating-from">
                    Migrating From
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ti ti-transfer" />{" "}
                      {/* Icon for migration */}
                    </span>
                    <input
                      type="text"
                      id="lead-migrating-from"
                      className="form-control"
                      placeholder="Enter migrating from (e.g., Competitor X)"
                      value={formData.migrating_from}
                      onChange={(e) =>
                        handleInputChange("migrating_from", e.target.value)
                      }
                    />
                  </div>
                </div>
                {/* Lead Value */}
                <div className="col-md-6 col-sm-12 mb-3">
                  <label className="form-label" htmlFor="lead-value">
                    Quoted Value
                  </label>
                  <input
                    type="text"
                    id="lead-value"
                    className="form-control"
                    placeholder="Enter quoted value"
                    value={formData.lead_value}
                    onChange={(e) =>
                      handleInputChange("lead_value", e.target.value)
                    }
                  />
                </div>

                {/* Currency */}
                <div className="col-md-6 col-sm-12 mb-3">
                  <label className="form-label" htmlFor="lead-currency">
                    Currency <span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ti ti-currency-dollar" />{" "}
                      {/* Currency icon */}
                    </span>
                    <div className="flex-grow-1">
                      <Select
                        inputId="lead-currency"
                        options={Currency}
                        value={Currency.find(
                          (opt) => opt.value === formData.Currency
                        )}
                        onChange={(opt) =>
                          handleInputChange(
                            "Currency" as keyof CreateLeadPayload,
                            opt?.value || ""
                          )
                        }
                      />
                    </div>
                  </div>
                </div>

                {/* Lead Status */}
                <div className="col-md-6 col-sm-12 mb-3">
                  <label className="form-label" htmlFor="lead-status">
                    Lead Status <span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ti ti-check" />
                      {/* Status icon */}
                    </span>
                    <div className="flex-grow-1">
                      <Select
                        inputId="lead-status"
                        options={leadStatusOptions}
                        value={leadStatusOptions.find(
                          (opt) => opt.value === formData.lead_status
                        )}
                        onChange={(opt) =>
                          handleInputChange("lead_status", opt?.value || "")
                        }
                      />
                    </div>
                  </div>
                </div>

                {/* Owner */}
                <div className="col-md-6 col-sm-12 mb-3">
                  <Form.Group className="mb-3">
                    <Form.Label htmlFor="lead-owner">Assign To</Form.Label>
                    {formData.leadowner_id ? (
                      <div className="form-control bg-light">
                        {users.find((user) => user.id === formData.leadowner_id)
                          ?.name || "N/A"}
                      </div>
                    ) : (
                      <Select
                        inputId="lead-owner"
                        options={userOptions}
                        value={userOptions.find(
                          (opt) => opt.value === formData.leadowner_id
                        )}
                        onChange={(selected) =>
                          handleInputChange(
                            "leadowner_id",
                            selected?.value || ""
                          )
                        }
                        placeholder="Select Assign To"
                      />
                    )}
                  </Form.Group>
                </div>

                {/* Description */}
                <div className="col-md-12 col-sm-12 mb-3">
                  <label className="form-label" htmlFor="lead-description">
                    Lead Description
                  </label>
                  <textarea
                    id="lead-description"
                    className="form-control"
                    rows={5}
                    value={formData.lead_description}
                    placeholder="Enter lead description (optional)"
                    onChange={(e) =>
                      handleInputChange("lead_description", e.target.value)
                    }
                  />
                </div>
              </div>

              <div className="text-end">
                <button
                  type="button"
                  className="btn btn-secondary me-2"
                  onClick={handleClose2}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSubmit}
                >
                  Create Lead
                </button>
              </div>
            </form>
          </div>
        </Offcanvas>
        {/* /Add Lead */}
        {/* Edit Lead */}
        <Offcanvas show={show3} onHide={handleClose3} placement="end">
          <div className="offcanvas-header border-bottom">
            <h4 className="fw-semibold">Edit Lead</h4>
            <button
              type="button"
              className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
              onClick={handleClose3}
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>

          <div className="offcanvas-body">
            <form>
              <h6 className="mt-3 mb-3 border-bottom pb-1">
                <i className="ti ti-building me-2 text-primary" />
                Company Info
              </h6>
              <div className="row">
                <div className="col-md-12 col-sm-12 mb-3">
                  <label
                    className="form-label"
                    htmlFor="edit-lead-company-name"
                  >
                    Company Name
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ti ti-building" />{" "}
                      {/* Company/Organization icon */}
                    </span>
                    <div className="flex-grow-1">
                      <Select
                        inputId="edit-lead-company-name"
                        options={companies.map((company) => ({
                          label: company.company.company_name,
                          value: company.company.contact_id,
                          fullCompany: company,
                        }))}
                        value={companies
                          .map((company) => ({
                            label: company.company.company_name,
                            value: company.company.contact_id,
                            fullCompany: company,
                          }))
                          .find(
                            (opt) => opt.value === editLeadFormData.contact_id
                          )}
                        onChange={handleEditCompanyChange}
                        isDisabled={true}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-6 col-sm-12 mb-3">
                  <label className="form-label" htmlFor="edit-lead-name">
                    Lead Name
                  </label>
                  <input
                    type="text"
                    id="edit-lead-name"
                    className="form-control"
                    value={editLeadFormData.contact_name || ""}
                    disabled
                  />
                </div>

                <div className="col-md-6 col-sm-12 mb-3">
                  <label className="form-label" htmlFor="edit-lead-branch">
                    Select Branch
                  </label>
                  <Select
                    inputId="edit-lead-branch"
                    options={
                      selectedCompany?.branches?.map((branch: Branch) => ({
                        label: `${branch.branch_name} - ${branch.branch_city}, ${branch.branch_state}`,
                        value: branch.branch_id,
                      })) || []
                    }
                    value={
                      selectedBranch
                        ? {
                            label: `${selectedBranch.branch_name} - ${selectedBranch.branch_city}, ${selectedBranch.branch_state}`,
                            value: selectedBranch.branch_id,
                          }
                        : null
                    }
                    onChange={(selectedOption) => {
                      const branch = selectedCompany?.branches?.find(
                        (b: Branch) => b.branch_id === selectedOption?.value
                      );
                      setSelectedBranch(branch);
                      setEditLeadFormData((prev) => ({
                        ...prev,
                        branch_id: branch?.branch_id || "",
                      }));
                    }}
                    //isDisabled={!selectedCompany}
                  />
                </div>

                <div className="col-md-6 col-sm-12 mb-3">
                  <label className="form-label" htmlFor="edit-lead-phone">
                    Phone
                  </label>
                  <input
                    type="text"
                    id="edit-lead-phone"
                    className="form-control"
                    value={editLeadFormData.company_phone || ""}
                    readOnly
                  />
                </div>

                <div className="col-md-6 col-sm-12 mb-3">
                  <label className="form-label" htmlFor="edit-lead-website">
                    Website URL
                  </label>
                  <input
                    type="text"
                    id="edit-lead-website"
                    className="form-control"
                    value={editLeadFormData.website_url || ""}
                    readOnly
                  />
                </div>
              </div>

              <h6 className="mt-4 mb-3 border-bottom pb-1">
                <i className="ti ti-users me-2 text-primary" />
                Lead Details
              </h6>
              {selectedLead?.deal_status === "won" && (
                <div
                  className="alert alert-success d-flex align-items-center mb-4"
                  role="alert"
                >
                  <i className="ti ti-trophy me-2 fs-20"></i>
                  <div>
                    <strong> Deal Won!</strong>
                    <br />
                    This lead is won in status. So, Lead Status and Stage Cannot
                    be edited.
                  </div>
                </div>
              )}
              <div className="row">
                <div className="col-md-6 col-sm-12 mb-3">
                  <label className="form-label" htmlFor="edit-lead-source">
                    Lead Source
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ti ti-database" /> {/* Lead Source icon */}
                    </span>
                    <div className="flex-grow-1">
                      <input
                        type="text"
                        id="edit-lead-source"
                        className="form-control"
                        value={editLeadFormData.leadsource_name || ""}
                        readOnly
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-6 col-sm-12 mb-3">
                  <label className="form-label" htmlFor="edit-lead-givenby">
                    Lead Given By<span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ti ti-user" /> {/* Lead Given By icon */}
                    </span>
                    <div className="flex-grow-1">
                      <Select
                        inputId="edit-lead-givenby"
                        options={leadGivenByOptions}
                        value={leadGivenByOptions.find(
                          (opt) => opt.value === editLeadFormData.leadgivenby_id
                        )}
                        onChange={(selected) =>
                          setEditLeadFormData({
                            ...editLeadFormData,
                            leadgivenby_id: selected ? selected.value : "",
                          })
                        }
                        placeholder="Select Lead Given By"
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-6 col-sm-12 mb-3">
                  <label
                    className="form-label"
                    htmlFor="edit-lead-business-type"
                  >
                    Lead Business Type
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ti ti-file-invoice" />{" "}
                      {/* Business / Industry icon */}
                    </span>
                    <div className="flex-grow-1">
                      <Select
                        inputId="edit-lead-business-type"
                        options={industryOptions}
                        value={industryOptions.find(
                          (opt) =>
                            opt.value === editLeadFormData.leadindustry_id
                        )}
                        onChange={(selected) =>
                          setEditLeadFormData({
                            ...editLeadFormData,
                            leadindustry_id: selected?.value || "",
                          })
                        }
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-6 col-sm-12 mb-3">
                  <label className="form-label" htmlFor="edit-lead-type">
                    Lead Type
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ti ti-category" />{" "}
                      {/* Category/Type icon */}
                    </span>
                    <div className="flex-grow-1">
                      <Select
                        inputId="edit-lead-type"
                        options={leadTypeOptions}
                        value={leadTypeOptions.find(
                          (opt) => opt.value === editLeadFormData.leadtype_id
                        )}
                        onChange={(selected) =>
                          setEditLeadFormData({
                            ...editLeadFormData,
                            leadtype_id: selected?.value || "",
                          })
                        }
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-6 col-sm-12 mb-3">
                  <label className="form-label" htmlFor="edit-lead-stage">
                    Lead Stage
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="bi bi-boxes" /> {/* Stage/Flag icon */}
                    </span>
                    <div className="flex-grow-1">
                      <Select
                        inputId="edit-lead-stage"
                        options={leadStageOptions}
                        value={leadStageOptions.find(
                          (opt) => opt.value === editLeadFormData.leadstage_id
                        )}
                        onChange={(selected) =>
                          setEditLeadFormData({
                            ...editLeadFormData,
                            leadstage_id: selected?.value || "",
                          })
                        }
                        isDisabled={selectedLead?.deal_status === "won"}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-6 col-sm-12 mb-3">
                  <label className="form-label" htmlFor="edit-lead-product">
                    Product
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="bi bi-box-seam" />{" "}
                      {/* Package/Product icon */}
                    </span>
                    <div className="flex-grow-1">
                      <Select
                        inputId="edit-lead-product"
                        options={productOptions}
                        value={productOptions.find(
                          (opt) => opt.value === editLeadFormData.product_id
                        )}
                        onChange={(selected) => {
                          setEditLeadFormData({
                            ...editLeadFormData,
                            product_id: selected?.value || "",
                          });
                          if (selected && "data" in selected) {
                            setSelectedEditProduct(selected);
                          } else {
                            setSelectedEditProduct(null);
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>

                {selectedEditProduct && (
                  <>
                    <div className="col-md-6 col-sm-12 mb-3">
                      <label className="form-label" htmlFor="edit-lead-logins">
                        No. of Logins
                      </label>
                      <input
                        type="text"
                        id="edit-lead-logins"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        className="form-control"
                        value={
                          editLeadFormData.no_logins === undefined
                            ? ""
                            : editLeadFormData.no_logins
                        }
                        onChange={(e) => {
                          const value = e.target.value;

                          if (value === "") {
                            setEditLeadFormData((prev) => ({
                              ...prev,
                              no_logins: undefined,
                            }));
                            return;
                          }

                          const logins = parseInt(value, 10);
                          if (!isNaN(logins)) {
                            setEditLeadFormData((prev) => ({
                              ...prev,
                              no_logins: logins,
                              rate_per_login:
                                selectedEditProduct?.data?.product_price || 0, // just fetch price
                            }));
                          }
                        }}
                      />
                    </div>
                    <div className="col-md-6 col-sm-12 mb-3">
                      <label className="form-label" htmlFor="edit-lead-rate">
                        Rate per Login
                      </label>
                      <input
                        type="text"
                        id="edit-lead-rate"
                        className="form-control"
                        value={`₹${
                          selectedEditProduct?.data?.product_price || 0
                        }`} // directly show product price
                        readOnly
                      />
                    </div>
                  </>
                )}

                {/* Product Type */}
                <div className="col-md-6 col-sm-12 mb-3">
                  <label
                    className="form-label"
                    htmlFor="edit-lead-product-type"
                  >
                    Product Type
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ti ti-box" /> {/* Box/Product Type icon */}
                    </span>
                    <div className="flex-grow-1">
                      <Select
                        inputId="edit-lead-product-type"
                        options={productTypeOptions}
                        value={
                          productTypeOptions.find(
                            (opt) =>
                              opt.value === editLeadFormData.product_type_id
                          ) || null
                        }
                        onChange={(opt) =>
                          setEditLeadFormData((prev) => ({
                            ...prev,
                            product_type_id: opt?.value,
                          }))
                        }
                      />
                    </div>
                  </div>
                </div>

                {/* Customer Type */}
                <div className="col-md-6 col-sm-12 mb-3">
                  <label
                    className="form-label"
                    htmlFor="edit-lead-customer-type"
                  >
                    Customer Type
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ti ti-trending-up" />{" "}
                      {/* Growth/Potential icon */}
                    </span>
                    <div className="flex-grow-1">
                      <Select
                        inputId="edit-lead-customer-type"
                        options={customerTypeOptions}
                        value={
                          customerTypeOptions.find(
                            (opt) =>
                              opt.value ===
                              editLeadFormData.customerPotential_id
                          ) || null
                        }
                        onChange={(opt) =>
                          setEditLeadFormData((prev) => ({
                            ...prev,
                            customerPotential_id: opt?.value,
                          }))
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              <h6 className="mt-4 mb-3 border-bottom pb-1">
                <i className="ti ti-file-description me-2 text-primary" />
                Additional Info
              </h6>
              <div className="row">
                {/* Migrating From */}
                <div className="col-md-6 col-sm-12 mb-3">
                  <label
                    className="form-label"
                    htmlFor="edit-lead-migrating-from"
                  >
                    Migrating From <span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ti ti-transfer" />
                    </span>
                    <input
                      type="text"
                      id="edit-lead-migrating-from"
                      className="form-control"
                      placeholder="Enter migrating from (e.g., Competitor X)"
                      value={editLeadFormData.migrating_from || ""}
                      onChange={(e) =>
                        setEditLeadFormData({
                          ...editLeadFormData,
                          migrating_from: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
                <div className="col-md-6 col-sm-12 mb-3">
                  <label className="form-label" htmlFor="edit-lead-value">
                    Quoted Value
                  </label>
                  <input
                    type="text"
                    id="edit-lead-value"
                    className="form-control"
                    value={editLeadFormData.lead_value || ""}
                    onChange={(e) =>
                      setEditLeadFormData({
                        ...editLeadFormData,
                        lead_value: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="col-md-6 col-sm-12 mb-3">
                  <label className="form-label" htmlFor="edit-lead-currency">
                    Currency
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ti ti-currency-dollar" />{" "}
                      {/* Currency icon */}
                    </span>
                    <div className="flex-grow-1">
                      <Select
                        inputId="edit-lead-currency"
                        options={Currency}
                        value={Currency.find(
                          (opt) => opt.value === editLeadFormData.Currency
                        )}
                        onChange={(opt) =>
                          setEditLeadFormData({
                            ...editLeadFormData,
                            Currency: opt?.value || "",
                          })
                        }
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-6 col-sm-12 mb-3">
                  <label className="form-label" htmlFor="edit-lead-status">
                    Lead Status
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ti ti-check" />
                      {/* Status icon */}
                    </span>
                    <div className="flex-grow-1">
                      <Select
                        inputId="edit-lead-status"
                        options={leadStatusOptions}
                        value={leadStatusOptions.find(
                          (opt) => opt.value === editLeadFormData.lead_status
                        )}
                        onChange={(opt) =>
                          setEditLeadFormData({
                            ...editLeadFormData,
                            lead_status: opt?.value || "",
                          })
                        }
                        isDisabled={selectedLead?.deal_status === "won"}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-6 col-sm-12 mb-3">
                  <label className="form-label" htmlFor="edit-lead-assign">
                    Assign To (User)
                  </label>
                  <Select
                    inputId="edit-lead-assign"
                    options={userOptions}
                    value={userOptions.find(
                      (opt) => opt.value === editLeadFormData.user_id
                    )}
                    onChange={(opt) =>
                      setEditLeadFormData({
                        ...editLeadFormData,
                        user_id: opt?.value || "",
                      })
                    }
                  />
                </div>
                <div className="col-md-6 col-sm-12 mb-3">
                  <label className="form-label" htmlFor="edit-lead-contributor">
                    Lead Contributor
                  </label>
                  <Select
                    isMulti
                    options={userOptions}
                    value={selectedContributors}
                    onChange={(
                      selected: MultiValue<{ label: string; value: string }>
                    ) => {
                      const mutableSelected = [...selected]; // convert readonly → mutable array
                      setSelectedContributors(mutableSelected);
                      setEditLeadFormData((prev) => ({
                        ...prev,
                        leadcontributor_id: mutableSelected
                          .map((opt) => opt.value)
                          .join(","), // comma separated
                      }));
                    }}
                  />
                </div>

                <div className="col-md-12 col-sm-12 mb-3">
                  <label className="form-label" htmlFor="edit-lead-description">
                    Lead Description
                  </label>
                  <textarea
                    id="edit-lead-description"
                    className="form-control"
                    rows={4}
                    value={editLeadFormData.lead_description || ""}
                    onChange={(e) =>
                      setEditLeadFormData({
                        ...editLeadFormData,
                        lead_description: e.target.value,
                      })
                    }
                  />
                </div>
              </div>

              <div className="text-end">
                <button
                  type="button"
                  className="btn btn-secondary me-2"
                  onClick={handleClose3}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleEditLeadSubmit}
                >
                  Update
                </button>
              </div>
            </form>
          </div>
        </Offcanvas>
        {/* /Edit Lead */}
        {/* Delete Lead */}
        <ModalDeleteEffect />
        <div
          className="modal fade effect-modal-show"
          id="delete_lead"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="deleteLeadLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title text-danger fw-bold" id="deleteLeadLabel">
                  <i className="ti ti-alert-triangle me-2" />
                  Confirm Deletion
                </h5>
                <button
                  type="button"
                  className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  disabled={isDeleting}
                  onClick={() => {
                    if (!isDeleting) {/* optional: close logic if needed */ }
                  }}
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <div className="modal-body text-center">
                <div className="avatar avatar-xl bg-danger-light rounded-circle mb-4 mx-auto effect-avatar-pulse">
                  <i className="ti ti-trash fs-40 text-danger" />
                </div>

                {/* Dynamic lead name display */}
                {leadIdToDelete &&
                  leads.find((l) => l.lead_id === leadIdToDelete) && (
                    <h4 className="fw-bold text-dark mb-3">
                      Delete "
                      {leads.find((l) => l.lead_id === leadIdToDelete)?.contact?.company_name ||
                        leads.find((l) => l.lead_id === leadIdToDelete)?.contact?.contact_person_name ||
                        "this lead"}
                      "?
                    </h4>
                  )}

                {!leadIdToDelete && (
                  <h4 className="fw-bold text-dark mb-3">Delete This Lead?</h4>
                )}

                <p className="text-muted fs-15 mb-4 px-4">
                  This action <strong>cannot be undone</strong>. The lead will be
                  <strong> permanently removed</strong> from your system.
                </p>

                <div className="alert alert-warning py-3 mx-4 mb-4 rounded-3 border-warning">
                  <i className="ti ti-info-circle me-2" />
                  <strong>Warning:</strong> All associated data (notes, calls, emails, follow-ups) will also be deleted.
                </div>

                <div className="d-flex gap-3 justify-content-center mt-4">
                  <button
                    type="button"
                    className="btn btn-light px-5 py-2 fw-medium"
                    data-bs-dismiss="modal"
                    disabled={isDeleting}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger px-5 py-2 fw-medium"
                    onClick={() => {
                      if (leadIdToDelete) handleDeleteLead(leadIdToDelete);
                    }}
                    data-bs-dismiss="modal"
                    disabled={isDeleting}
                  >
                    {isDeleting ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        />
                        Deleting...
                      </>
                    ) : (
                      <>
                        <i className="ti ti-trash me-2" />
                        Yes, Delete It
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Delete Lead */}
        {/* Create Lead */}
        <Modal
          show={openModal2}
          onHide={() => setOpenModal2(false)}
          centered
          backdrop="static"
        >
          <div className="modal-header border-0 justify-content-end p-3">
            <button
              className="btn-close"
              onClick={() => setOpenModal2(false)}
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>

          <div className="modal-body text-center pb-4">
            <div className="success-message">
              <div className="success-popup-icon bg-light-blue mx-auto mb-3 rounded-circle p-3">
                <i className="ti ti-building fs-36 text-primary" />
              </div>
              <h4 className="fw-semibold mb-1 text-success">
                Lead Created Successfully!
              </h4>
              <p className="text-muted mb-4">
                You can now view the full lead details.
              </p>

              <div className="d-flex justify-content-center gap-3">
                <button
                  type="button"
                  className="btn btn-light px-4"
                  data-bs-dismiss="modal"
                  onClick={() => setOpenModal2(false)}
                >
                  Cancel
                </button>
                <Link
                  to={route.leadsDetails}
                  //state={Lead}
                  className="btn btn-primary px-4"
                  onClick={() => setOpenModal2(false)}
                >
                  View Details
                </Link>
              </div>
            </div>
          </div>
        </Modal>
       <Modal
          show={showBulkDeleteModal}
          onHide={() => {
            if (!isDeleting) setShowBulkDeleteModal(false);
          }}
          centered
          backdrop="static"
          className="effect-modal-show"
        >
          <div className="modal-header">
            <h5 className="modal-title text-danger fw-bold" id="bulkDeleteLeadsLabel">
              <i className="ti ti-alert-triangle me-2" />
              Confirm Bulk Deletion
            </h5>
            <button
              className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
              aria-label="Close"
              onClick={() => {
                if (!isDeleting) setShowBulkDeleteModal(false);
              }}
              disabled={isDeleting}
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="modal-body text-center">
            <div className="avatar avatar-xl bg-danger-light rounded-circle mb-4 mx-auto effect-avatar-pulse">
              <i className="ti ti-trash fs-40 text-danger" />
            </div>
            <h4 className="fw-bold text-dark mb-3">
              Delete {selectedLeads.length} Lead{selectedLeads.length > 1 ? "s" : ""}?
            </h4>
            <p className="text-muted fs-15 mb-4 px-4">
              This action <strong>cannot be undone</strong>. The selected leads will be
              <strong> permanently removed</strong> from your system.
            </p>
            <div className="alert alert-warning py-3 mx-4 mb-4 rounded-3 border-warning">
              <i className="ti ti-info-circle me-2" />
              <strong>Warning:</strong> This may affect related records, notes, call history, follow-ups, and email marketing data.
            </div>

            <div className="d-flex gap-3 justify-content-center mt-4">
              <button
                type="button"
                className="btn btn-light px-5 py-2 fw-medium"
                onClick={() => setShowBulkDeleteModal(false)}
                disabled={isDeleting}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-danger px-5 py-2 fw-medium"
                onClick={async () => {
                  setIsDeleting(true);
                  try {
                    await handleBulkDelete();
                    setShowBulkDeleteModal(false);
                  } finally {
                    setIsDeleting(false);
                  }
                }}
                disabled={isDeleting}
              >
                {isDeleting ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    />
                    Deleting...
                  </>
                ) : (
                  <>
                    <i className="ti ti-trash me-2" />
                    Yes, Delete Permanently
                  </>
                )}
              </button>
            </div>
          </div>
        </Modal>

        <Modal
          show={showExportModal}
          onHide={() => setShowExportModal(false)}
          centered
          dialogAs={(props) => <div {...props} id="custom_export_modal" />}
          className="effect-modal-show"
        >
          <div
            id="custom_export_modal"
            className="modal fade show"
            style={{ display: "block" }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title text-primary fw-bold">
                    <i className="ti ti-file-export me-2" />
                    Customized Lead Export
                  </h5>
                  <button
                    className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
                    aria-label="Close"
                    onClick={() => setShowExportModal(false)}
                  >
                    <i className="ti ti-x" />
                  </button>
                </div>
                {selectedLeads.length === 0 && (
                  <div className="alert alert-warning py-2 mx-3 mt-3">
                    Please select at least one row from the table to export data.
                  </div>
                )}
                <div className="modal-body p-4">
                  <p className="text-muted mb-4">
                    Select columns to include in the export (
                    {selectedLeads.length} leads selected):
                  </p>
                  <div className="row">
                    <div className="col-md-12 mb-3">
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="export-col-all"
                          checked={allColumnsSelected}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelectedColumns(
                                exportColumns.map((c) => c.key)
                              );
                            } else {
                              setSelectedColumns([]);
                            }
                          }}
                        />
                        <label
                          className="form-check-label fw-semibold"
                          htmlFor="export-col-all"
                        >
                          Select All Columns
                        </label>
                      </div>
                      <hr />
                    </div>

                    {exportColumns.map((col) => (
                      <div className="col-md-6 mb-2" key={col.key}>
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={`export-col-${col.key}`}
                            checked={selectedColumns.includes(col.key)}
                            onChange={() => handleColumnSelect(col.key)}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`export-col-${col.key}`}
                          >
                            {col.label}
                          </label>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    className="btn btn-light px-4 py-2 fw-medium"
                    onClick={() => setShowExportModal(false)}
                  >
                    Cancel
                  </button>

                  <button
                    className="btn btn-primary px-4 py-2"
                    onClick={() => handleExportSubmit("pdf")}
                    disabled={selectedLeads.length === 0 || !hasSelectedColumn}
                  >
                    Export as PDF
                  </button>

                  <button
                    className="btn btn-primary px-4 py-2"
                    onClick={() => handleExportSubmit("excel")}
                    disabled={selectedLeads.length === 0 || !hasSelectedColumn}
                  >
                    Export as Excel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>

        {/* /Create Lead */}
         <LeadDetailsModal
        isOpen={isDetailsOpen}
        onClose={() => setIsDetailsOpen(false)}
        lead={selectedLeadForModal}
      />
      {/* Save Column Order Modal */}
      <SaveModal />
      <ScrollToTop />
      </>
    </>
  );
};

export default Leads;
